export type UiLanguage = 'en' | 'zh';

const CATALOG = {
  en: {
    graphMyAnswers: 'My answers',
    graphOurTalks: 'Our Talks',
    graphPlaceHistory: 'Your exchanges here',
    graphPlaceEmpty: 'No recorded exchanges in this Place.',
    graphUnknownPlace: 'Place',
    navChatrooms: 'Chatrooms',
    navContacts: 'Contacts',
    navTalks: 'Talks',
    navMe: 'Me',
    navSettings: 'Settings',
    statusContacts: 'Contacts from exchanged talks',
    statusTalks: 'Incoming talks are consolidated by content.',
    statusMe: 'Answered question history',
    statusSettings: 'Feature and filter controls',
    newRoom: 'New Room',
    returnHome: 'Return Home',
    broadcast: 'Broadcast',
    filters: 'Filters',
    chatroomCurrent: 'Current',
    chatroomViewMode: 'Chatroom view',
    chatroomListView: 'List',
    chatroomMapView: 'Map',
    chatroomMapAriaLabel: 'Map of geographic chatrooms',
    chatroomMapLoading: 'Loading map…',
    chatroomMapLoadFailed: 'The map could not be loaded. Check your connection or use List view.',
    chatroomMapLocateSelf: 'Center on me',
    chatroomMapSummary: 'Showing {count} Places.',
    chatroomMapCustomRoomsNote: '{count} Community-created Places without a public location remain in List view.',
    chatroomPlaceStartupUnavailable: 'IinPublic could not open your saved Place, so it opened Nearby instead.',
    chatroomSwitchFailed: 'IinPublic could not switch rooms. Please try again.',
    chatroomTraveler: 'Traveler',
    chatroomNearbyName: 'Nearby',
    chatroomCurrentGroupHeading: 'Your current group',
    matchCollectionTitle: 'Collect matches',
    matchCollectionHelp: 'Keep the people and replies from this outing together, then find the strongest matches.',
    matchCollectionStart: 'Start collecting',
    matchCollectionActiveTitle: 'Collecting matches',
    matchCollectionActiveSummary: '{elapsed} · {people} reached · {replies} replies · {pending} pending · {matches} matches',
    matchCollectionFinishedTitle: 'Last collection',
    matchCollectionFinishedSummary: '{elapsed} · {people} reached · {replies} replies · {pending} pending · {matches} matches',
    matchCollectionBroadcast: 'Broadcast into this collection',
    matchCollectionReview: 'Review collection',
    matchCollectionReviewTitle: 'Collection review',
    matchCollectionReviewSummary: '{people} reached · {replies} replies · {pending} pending · {matches} matches · {mismatches} mismatches · {late} late',
    matchCollectionNoPeople: 'No one has been reached in this collection yet.',
    matchCollectionPerson: 'Person {person}',
    matchCollectionPersonSummary: '{replies} replies · {pending} pending',
    matchCollectionOpenPerson: 'Open replies & chat',
    matchCollectionPin: 'Pin',
    matchCollectionUnpin: 'Unpin',
    matchCollectionDismiss: 'Dismiss',
    matchCollectionRestore: 'Restore',
    matchCollectionPrivateNote: 'Private note',
    matchCollectionLate: 'late',
    matchCollectionLocationSummary: '{areas} public areas · {unavailable} sends without a location fix',
    matchCollectionEncounterDistance: 'Encounter distance: about {distance}',
    matchCollectionImportanceLabel: 'Collection priority',
    matchCollectionImportanceNormal: 'Normal',
    matchCollectionImportanceImportant: 'Important',
    matchCollectionImportanceMustHave: 'Must-have',
    matchCollectionRankReason: 'Why: {reasons}',
    matchCollectionReasonPinned: 'pinned',
    matchCollectionReasonMustHave: 'must-have passed',
    matchCollectionReasonMatches: '{count} weighted matches',
    matchCollectionReasonBreadth: '{count} Talks matched',
    matchCollectionReasonNearby: 'met nearby',
    matchCollectionReasonRecent: 'recent reply',
    matchCollectionMustHaveFailures: '{count} must-have failures',
    matchCollectionFilterAll: 'All people',
    matchCollectionFilterMatches: 'Matched',
    matchCollectionFilterPending: 'Needs follow-up',
    matchCollectionPendingAction: 'Still waiting — open chat to follow up',
    matchCollectionStop: 'Stop collecting',
    matchCollectionDefaultLabel: 'Nearby outing',
    matchCollectionStarted: 'Match collection started. Broadcast your Talks when you are ready.',
    matchCollectionEnded: 'Match collection stopped. Late replies will stay with this outing.',
    settingsMatchCollection: 'Collect nearby matches',
    settingsMatchCollectionHelp: 'On by default. Keep nearby people and their Talk replies together automatically. Turn this off to stop collecting.',
    chatroomPlacesHeading: 'Places',
    chatroomPlacesEmpty: 'No public Places yet. Use Map to explore or create one.',
    chatroomNearbyHomeDescription: 'Based on your blurred home location',
    chatroomNearbyTravelDescription: 'Based on the map point you selected',
    chatroomContactsDescription: 'Stranger discovery is off',
    chatroomPlaceDescriptionFallback: 'A public Place anyone can join',
    chatroomCapacitySummary: '{count} people · up to {capacity}',
    chatroomNearbyPointTitle: 'Nearby around this point',
    chatroomNearbyPointAction: 'Join as traveler',
    quietEnded: 'Quiet ended: you are shown at your normal area again.',
    quietHidden: 'Quiet: you are hidden from Nearby and the map. Contacts still reach you.',
    quietBlurred: 'Quiet: you are shown only at a wide area (about 50 km).',
    quietHiddenNoTravel: 'Quiet is hiding you. Turn off Quiet now (or leave the quiet place) to join Nearby.',
    settingsDistanceUnit: 'Distance unit',
    settingsDistanceUnitKm: 'Kilometres (km)',
    settingsDistanceUnitMi: 'Miles (mi)',
    locationSectionTitle: 'Your location',
    locationSectionHelp: 'Everyone appears somewhere: at blurred GPS as a Resident, or at a point you choose as a Traveler ✈. Your exact position is never shared.',
    locationSourceTitle: 'Where you appear',
    locationSourceResident: 'Resident: my device location',
    locationSourceResidentHelp: 'Your GPS, blurred to the area below. You meet the people around you.',
    locationSourceTraveler: 'Traveler ✈: a point I choose',
    locationSourceTravelerHelp: 'Your GPS is never used. Others see you marked as a Traveler at the point you choose.',
    locationSourceWebOnly: 'This device cannot share its location, so you appear as a Traveler ✈ at a point you choose.',
    locationUseMine: 'Use my location',
    locationUseMineHelp: 'Location is off for this app, so you appear as a Traveler ✈. Allow location to appear where you are.',
    locationPermissionUnavailable: 'Location is not available. Allow location for IinPublic in your browser or device settings; until then you appear as a Traveler ✈ at your chosen point.',
    locationAreaTitle: 'Area others see',
    locationAreaClose: 'Close nearby — rooms within about {distance} (others see {shown})',
    locationAreaNeighborhood: 'Neighborhood — about {distance}',
    locationAreaCitywide: 'Citywide — about {distance}',
    locationAreaRegional: 'Regional — about {distance}',
    locationAreaHelp: 'Your dot is the centre of a square this size; everyone in the square shows at the same point. This square is also your Nearby: a larger one reveals less about where you are, but may put more people in your Nearby. Residents and Travelers ✈ use the same size.',
    quietTitle: 'Quiet places',
    quietHelp: 'Go quiet automatically at home, work or other places, and on a schedule. Quiet places stay on this device only.',
    quietNow: 'Quiet now',
    quietActionTitle: 'When quiet',
    quietActionBlur: 'Blur me more — show me only at about {distance} (recommended)',
    quietActionHide: 'Hide me — leave Nearby and the map (contacts still reach me)',
    quietPlacesTitle: 'Places',
    quietPlacesEmpty: 'No quiet places yet.',
    quietPlaceAdd: 'Add a quiet place on the map',
    quietPlaceName: 'Place name',
    quietPlaceRadius: 'Radius',
    quietPlaceRemove: 'Remove',
    quietPlaceDefaultName: 'Quiet place',
    quietSchedule: 'Every day',
    quietScheduleStart: 'Quiet from',
    quietScheduleEnd: 'Quiet until',
    quietLimits: 'Not a guarantee: if you are hidden every night from the same area, that pattern can hint where you live. Blur me more leaks less than hiding.',
    quietPickerTitle: 'Add a quiet place',
    quietPickerIntro: 'Tap the place where you want to go quiet, such as home or work.',
    quietPickerConfirm: 'Add quiet place',
    quietPickerDisclosure: 'Saved on this device only. It is never published or synced.',
    talkAudienceTitle: 'Exchange Talks with',
    talkAudienceEveryone: 'Everyone in my room',
    talkAudienceEveryoneHelp: 'Residents and Travelers in your Nearby or Place.',
    talkAudienceResidents: 'Residents only',
    talkAudienceResidentsHelp: 'Skip Travelers ✈ (including every website user). Travelers declare themselves, so this cannot stop someone who fakes GPS.',
    talkAudienceContacts: 'Contacts only',
    talkAudienceContactsHelp: 'No Talks with strangers. You still appear in rooms and on the map.',
    roomListAround: 'near {place}',
    roomListPeople: '{count} people',
    roomListYourRoom: 'Your room',
    nearbyPeopleNearYou: 'People near you',
    nearbyCountNearYou: '{count} nearby',
    nearbyCountOnline: '{count} nearby · {online} online',
    nearbyGroupFirst: 'Group 1 · the people nearest you',
    nearbyGroupNext: 'Group {group} · the next people near you',
    placeGroupFirst: 'Group 1 · people in this Place',
    placeGroupNext: 'Group {group} · the next people in this Place',
    nearbyGroupExhausted: "You've met everyone here for now.",
    nearbyGroupSearching: 'Looking for new people…',
    nearbyMeetNewPeople: 'Meet new people',
    nearbyBackToFirstGroup: 'Back to group 1',
    nearbyMeetConfirmTitle: 'Meet new people?',
    nearbyMeetConfirmBody: 'Swap these {count} people for the next people near you. Your active Talks go to them automatically. Anyone you matched stays in Contacts.',
    placeMeetConfirmBody: 'Swap these {count} people for the next people in this Place. Your active Talks go to them automatically. Anyone you matched stays in Contacts.',
    nearbySentProgress: 'Sent to {sent} of {total}',
    roomListPlaceTag: 'Place',
    roomListPlaceFallback: 'Place',
    roomListNearbyFallback: 'Nearby group',
    roomListHere: 'Here',
    roomListOnline: '{people} online · {rooms} rooms',
    roomListLoading: 'Loading rooms…',
    roomListSort: 'Sort',
    roomListSortNearest: 'Nearest',
    roomListSortBusiest: 'Busiest',
    roomListSortMostRoom: 'Fewest people',
    roomListNearHeading: 'Rooms near you',
    roomListEmpty: 'No other room has people right now.',
    roomListShowMore: 'Show more rooms',
    mapUserSelf: 'You',
    mapUserRoomOne: 'Someone in your Nearby: you can exchange Talks',
    mapUserRoomMany: '{count} people in your Nearby: you can exchange Talks',
    mapUserOtherOne: 'Someone outside your Nearby: travel there to exchange Talks',
    mapUserOtherMany: '{count} people outside your Nearby: travel there to exchange Talks',
    mapUserLegendSelf: 'You',
    mapUserLegendRoom: 'Can exchange Talks',
    mapUserLegendOther: 'Outside your Nearby',
    mapMemberMessage: 'Message',
    mapMemberProfile: 'Profile',
    mapOpenMe: 'Open Me',
    mapRelationship: 'Relationship',
    mapOpenTalks: 'Open Talks',
    mapTravelHere: 'Travel here',
    mapTalkCount: '{count} Talks',
    mapTalkOne: '1 Talk',
    mapTalksWith: 'With {name}',
    mapTalksEmpty: 'No exchanged Talks with this person are available on this device.',
    listBroadcastOutgoing: 'Sending ↓',
    listBroadcastIncoming: 'Receiving ↑',
    mapBroadcastOutgoing: 'Broadcasting to nearby people',
    mapBroadcastIncoming: 'Receiving a nearby broadcast',
    mapMemberMatched: 'Matched',
    mapMemberMatchCount: '{count} matched Talks · Open contact details',
    chatroomLoadingMembers: 'Loading members...',
    chatroomLoadingOnlineUsers: 'Loading online users...',
    chatroomRename: 'Rename',
    chatroomDelete: 'Delete room',
    chatroomMetrics: '👥 {members} total · 🚪 {visits} · ◎ {unique}',
    chatroomMemberOne: '{count} member',
    chatroomMembers: '{count} members',
    chatroomVisitOne: '{count} visit',
    chatroomVisits: '{count} visits',
    chatroomUniqueOne: '{count} unique visitor',
    chatroomUniqueVisitors: '{count} unique visitors',
    chatroomNoOtherUsers: 'No other users here yet',
    chatroomFirstHere: "You're the first one in this chatroom!",
    chatroomMatched: 'Matched',
    chatroomOnlineNow: 'Online now',
    chatroomMatchedCount: 'matched',
    chatroomMutualTag: 'mutual tag',
    chatroomMutualTags: 'mutual tags',
    chatroomOpenFirst: 'Open a chatroom from the list (tap a room), or wait until you are placed in one.',
    chatroomNoTalksToBroadcast: 'You have no talks to broadcast. Create one first or enable copied talks.',
    chatroomAlreadyBroadcast: 'Everything current has already been broadcast to this room.',
    chatroomCreateTitle: 'New chatroom',
    chatroomCreateHelp: 'Create a community or business room. Anyone can join from the list.',
    chatroomType: 'Type',
    chatroomTypeCommunity: 'Community / custom',
    chatroomTypeBusiness: 'Business',
    chatroomBusinessHeadline: 'Business headline (optional)',
    chatroomBusinessPlaceholder: 'Short tagline',
    chatroomDetails: 'Room details',
    chatroomDescription: 'Description',
    chatroomBusinessHeadlineLabel: 'Business headline',
    chatroomCapacity: 'Capacity',
    chatroomOwner: 'Owner',
    chatroomCreatedDate: 'Created',
    chatroomActiveMembers: 'Active members',
    chatroomLifetimeVisits: 'Lifetime visits',
    chatroomUniqueVisitorsLabel: 'Unique visitors',
    chatroomName: 'Name',
    chatroomDescriptionOptional: 'Description (optional)',
    chatroomCapacityOptional: 'Capacity (optional)',
    chatroomCapacityPlaceholder: 'Default 50',
    chatroomCancel: 'Cancel',
    chatroomCreate: 'Create',
    chatroomNameTooShort: 'Name must be at least 2 characters.',
    chatroomCreateFailed: 'Could not create room.',
    chatroomCreateFailedWithReason: 'Could not create room: {reason}',
    chatroomCreated: '{name} created.',
    chatroomRenameTitle: 'Rename room',
    chatroomCurrentName: 'Current: {name}',
    chatroomNewName: 'New name',
    chatroomSave: 'Save',
    chatroomRenameFailed: 'Rename failed.',
    chatroomRenameFailedWithReason: 'Rename failed: {reason}',
    chatroomRenamed: 'Room renamed.',
    chatroomDeleteConfirm: 'Delete this room? It will disappear from the list for everyone.',
    chatroomDeleteFailed: 'Delete failed.',
    chatroomDeleteFailedWithReason: 'Delete failed: {reason}',
    chatroomDeleted: 'Room deleted.',
    talksBroadcastDisabled: 'Broadcasting disabled',
    talksBroadcastEnabled: 'Broadcasting enabled',
    broadcastNoChatroom: 'No chatroom selected.',
    broadcastInProgress: 'Broadcasting…',
    broadcastCancelled: 'Broadcast cancelled.',
    broadcastSentOneOne: 'Sent {talks} talk to {users} user in this chatroom.',
    broadcastSentOneMany: 'Sent {talks} talk to {users} users in this chatroom.',
    broadcastSentManyOne: 'Sent {talks} talks to {users} user in this chatroom.',
    broadcastSentManyMany: 'Sent {talks} talks to {users} users in this chatroom.',
    broadcastFailed: 'Failed to broadcast talks: {reason}',
    travelEnabled: 'Travel mode enabled. Select any room to travel there.',
    travelReturnedHomeRoom: 'Returned to home room.',
    travelReturnedHome: 'Returned home.',
    travelHomeSet: 'Home room set to {name}.',
    chatroomMapEnterTile: 'Enter ›',
    chatroomCreateNeedsLocation: 'A room is local to where you are. Turn on location to create one.',
    chatroomCreateNeedsCredit: 'To create your one room, at least {requiredFriends} people must mark you as a Friend and no more than {maximumBlocks} people may block you. You have {friends} Friend marks and {blocks} blocks.',
    chatroomTrademarkNotice: 'Use only a name and description you have the right to use. Respect trademark and other laws. A room does not prove you own a business or brand.',
    chatroomCreateNameTaken: '"{name}" already exists here. Joining it.',
    chatroomCreateCreatorLimit: 'You already have a room, "{name}". Each person can have one.',
    chatroomCreateCellFull: 'This area already has {count} rooms. Join one of them instead.',
    roomListPlacesNearHeading: 'Places near you',
    travelLocationHeld: 'Travel mode is on - location updated without switching rooms.',
    travelMovedLocation: 'Moved to new chatroom based on location',
    locationUpdateFailed: 'Failed to update location: {reason}',
    filterByName: 'Filter by name',
    repliesTitle: 'Replies To My Talks',
    clear: 'Clear',
    pinItem: 'Pin to top',
    unpinItem: 'Unpin from top',
    back: 'Back',
    loading: 'Loading...',
    unavailable: 'Unavailable',
    all: 'All',
    allRelations: 'All relations',
    friends: 'Friends',
    relatives: 'Relatives',
    coworkers: 'Coworkers',
    acquaintances: 'Acquaintances',
    partners: 'Partners',
    custom: 'Custom',
    recent: 'Recent',
    talkCount: 'Talk count',
    matchedTalks: 'Matched talks',
    matchRate: 'Match rate',
    relevanceScore: 'Relevance score',
    name: 'Name',
    contactsBroadcastGroupBtn: 'Broadcast to group…',
    contactsOpenDm: 'Open direct message',
    broadcastGroupTitle: 'Broadcast to a contact group',
    broadcastGroupPickGroup: 'Group',
    broadcastGroupPickTalk: 'Talk',
    broadcastGroupPreview: '{count} people — online now get it immediately, others get it when they next come online (dropped after the usual wait window)',
    broadcastGroupEmpty: 'No one in that group yet',
    broadcastGroupSent: 'Sent to the group',
    talksAll: 'All',
    talksLatestActivity: 'Latest activity',
    talksOldestCreation: 'Oldest creation',
    talksLatestReply: 'Latest reply',
    talksMostMatches: 'Most matches',
    talksMostReplies: 'Most replies',
    talksBestMatchRate: 'Best match rate',
    talksWeightedPerformance: 'Weighted performance',
    talksTitle: 'Title',
    talksStatusSummary: '{incoming} incoming · {outgoing} outgoing',
    talksNoTalks: 'One answer. Hundreds of conversations.',
    talksNoTalksHelp: 'Write a Talk in natural language, or answer one from someone else.',
    talksStats: 'Responses: {responses} · Matches: {matches} · Mismatches: {mismatches} · Ignores: {ignores} · Match rate: {rate}%',
    talksNoStats: '—',
    talksWeightedScore: 'Score {score} = matches x100 + match rate x25 + replies (max 20) - ignores x4 - mismatches x2',
    talksLatestReplyLabel: 'Latest reply: {date}',
    talksMatchedWith: 'Matched with: {names}',
    talksAlsoExchangedWith: 'Also exchanged with: {names}',
    talksCopied: 'Copied',
    talksCreated: 'Created',
    talksResults: 'Results',
    surveyDefaultTitle: 'Survey',
    surveyConnectResults: 'Connect to the server to load survey results.',
    surveyAnalyticsTitle: 'Survey analytics dashboard',
    surveyLoading: 'Loading...',
    surveyCreateFollowUp: 'Create follow-up survey',
    surveyClose: 'Close',
    surveyLoadFailed: 'Could not load dashboard ({status}). {detail}',
    surveyNetworkError: 'Network error while loading survey analytics dashboard.',
    surveyResponses: 'Responses',
    surveyQuestions: 'Questions',
    surveyRegions: 'Regions',
    surveyLatestDayBucket: 'Latest day bucket',
    surveyAnonymizeCohorts: 'Anonymize small cohorts (< {count} responses)',
    surveyExportSummary: 'Export summary CSV',
    surveyExportDay: 'Export by-day CSV',
    surveyExportRegion: 'Export region CSV',
    surveyNoQuestionBreakdown: 'No per-question breakdown yet. Responses will appear here after people answer.',
    surveyHiddenUntil: 'Hidden to preserve anonymity until this question has at least {count} responses.',
    surveyAnswersRecordedOne: '{count} answer recorded',
    surveyAnswersRecorded: '{count} answers recorded',
    surveyHiddenRegion: 'Hidden region',
    surveyUnknownRegion: 'unknown',
    surveyNoFollowUpGaps: 'No immediate follow-up gaps detected.',
    surveyFollowUpCandidates: 'Follow-up candidates: {questions}',
    surveyQuestionDistribution: 'Per-question distribution',
    surveyResponsesByDay: 'Responses by day',
    surveyResponsesByRegion: 'Responses by region',
    surveyBucket: 'Bucket',
    surveyCount: 'Count',
    surveyNoResponses: 'No responses yet.',
    surveyNoRegionData: 'No regional data yet.',
    surveyFollowUpHandling: 'Follow-up handling',
    surveyFollowUpHelp: 'Use "Create follow-up survey" to start a new survey from this dashboard. It pre-fills questions from your current survey and labels it as a follow-up to {title}.',
    surveyExported: 'Exported {filename}',
    surveyFollowUpTitle: 'Follow-up: {title}',
    surveyFollowUpQuestion: 'What should we improve next based on this survey?',
    surveyFollowUpDetails: 'Follow-up details',
    surveyNoFollowUpNeeded: 'No follow-up needed',
    surveyLocalData: 'Computed from your local response history.',
    surveySkipRate: 'Skip rate',
    surveyCompletionRateLabel: 'Completion',
    surveyCrossQuestion: 'Cross-question correlation',
    surveyCrossQuestionEmpty: 'Need at least 2 answered questions with ≥ {count} responses each to show correlations.',
    surveyFilterLabel: 'Filter responses',
    surveyFilterAll: 'All time',
    surveyFilterDays7: 'Last 7 days',
    surveyFilterDays30: 'Last 30 days',
    surveyFilterDays90: 'Last 90 days',
    surveyTimeSeries: 'Response trend',
    surveyTimeSeriesWeek: 'Responses by week',
    surveyTimeSeriesMonth: 'Responses by month',
    surveyMatchIgnoreBreakdown: 'Outcome breakdown',
    statsLocalDashboard: 'My talk statistics',
    statsLocalEmpty: 'No responses to your talks yet.',
    statsLocalNote: 'Statistics are computed locally from response history on this device.',
    statsByTypeHeader: 'By talk type',
    statsTopTalksHeader: 'Top talks (by responses)',
    statsTimeTrendHeader: 'Response trend (all talks)',
    statsChatroomHeader: 'By chatroom / location',
    statsPeerHeader: 'Peer response summary',
    statsBroadcastTagsHeader: 'Broadcast tags',
    talksBroadcastOff: 'Broadcast Off',
    talksBroadcastOn: 'Broadcast On',
    talksRemove: 'Remove',
    talksDetails: 'Details',
    talksExpiration: 'Expiration: {value}',
    talksLocation: 'Location: {value}',
    talksAnswered: 'Answered',
    talksNew: 'New',
    talksTagChecked: 'Checked tag',
    talksTagUndetermined: 'Unchecked tag',
    talksTagQuickDecision: 'Check to accept this tag',
    talksTagDecisionActions: 'Tag decision',
    talksTagPass: 'Pass',
    talksOutgoingSection: 'Outgoing',
    talksTapHint: 'Tap a tag to like it · tap a liked tag in Outgoing to pass it · long-press to select for ✕ ♡ 📌',
    talksTapModePass: 'Pass the selected tag (long-press a row to select it)',
    talksTapModeLike: 'Like the selected tag (long-press a row to select it)',
    talksTapModePin: 'Pin or unpin the selected row (long-press a row to select it)',
    talksTagLike: 'Like',
    talksTagPassed: 'Passed tag',
    talksTagLiked: 'Liked tag',
    talksIgnore: 'Ignore',
    talksIgnored: 'Talk moved to Ignored',
    talksRestore: 'Restore',
    talksRestored: 'Talk restored',
    talksResponseOne: '{count} response',
    talksResponses: '{count} responses',
    talksIncomingFallback: 'Incoming Talk',
    talksSenderOne: '{count} sender',
    talksSenders: '{count} senders',
    talksFrom: 'From: {names}',
    talksView: 'View',
    talksOutSection: '{count} · created or copied',
    talksInSection: '{count} · consolidated by content{filtered}',
    talksCountOne: '{count} talk',
    talksCount: '{count} talks',
    talksFilteredCount: ' · {count} filtered',
    talksAllIncomingFiltered: 'All incoming talks are currently filtered out ({count}).',
    talksNoIncoming: 'No incoming talks yet.',
    talksNoOutgoing: 'No outgoing talks yet.',
    talksJustNow: 'Just now',
    talksMinutesAgo: '{count}m ago',
    talksHoursAgo: '{count}h ago',
    talksDaysAgo: '{count}d ago',
    talksForever: 'Forever',
    talksExpired: 'Expired',
    talksExpiresIn: 'Expires in {value}',
    talksAnywhere: 'Anywhere',
    talksMiles: '{count} mi',
    talksDataNotFound: 'Talk data not found',
    talksAlreadyCopied: 'Already in My Talks',
    talksCopyToMyTalks: 'Copy to My Talks',
    talksRemoveCopy: 'Remove copy from My Talks',
    talksCopiedToList: 'Added to My Talks',
    talksCouldNotLoad: 'Could not load talk.',
    talksCouldNotOpen: 'Could not open talk.',
    talksCouldNotLoadRetry: 'Could not load this talk yet. Check your connection and try again.',
    nearbyOfflineWifiOff: 'No internet. Turn on Wi-Fi to find nearby phones — tap to open settings.',
    nearbyOfflineLocationOff: 'No internet. Turn on Location to find nearby phones — tap to open settings.',
    nearbyOfflineBluetoothOff: 'No internet. Turn on Bluetooth to find nearby phones — tap to open settings.',
    settingsNearby: 'Finding people nearby',
    appPermissionsTitle: 'App permissions',
    appPermissionsSubtitle: 'Asked once when you installed IinPublic. Change any of them in Android settings.',
    appPermissionNotifications: 'Notifications',
    appPermissionNotificationsHelp: 'New Talks, matches and messages while the app is in the background.',
    appPermissionLocation: 'Location',
    appPermissionLocationHelp: 'Puts you in the chatroom for where you are.',
    appPermissionNearby: 'Nearby devices',
    appPermissionNearbyHelp: 'Wi-Fi Direct and Bluetooth: find people around you, even offline.',
    appPermissionCamera: 'Camera',
    appPermissionCameraHelp: 'Scanning QR codes. Asked the first time you scan.',
    appPermissionAllowed: 'Allowed',
    appPermissionNotAllowed: 'Not allowed',
    appPermissionsOpenSystem: 'Change in Android settings',
    settingsNearbySubtitle: 'Choose which networks and radios IinPublic may use to find people in your chatroom — even with no internet.',
    settingsNearbyExchange: 'Nearby exchange',
    settingsNearbyModeOff: 'Off',
    settingsNearbyModeWhileOpen: 'While open — pauses in background',
    settingsNearbyModeAlways: 'Always — background Talk exchange',
    settingsNearbyModeHelp: 'Applies to the one active room. Changing rooms is always manual.',
    settingsNearbyCellular: 'Cellular (mobile data)',
    settingsNearbyCellularHelp: 'Off: IinPublic never uses your cellular network to find people in your chatroom. Every other network still works: on Wi-Fi it reaches iinpublic.com as usual, and nearby phones are found over Wi-Fi, Wi-Fi Direct and Bluetooth.',
    settingsNearbyLan: 'Find IinPublic phones on the same Wi-Fi',
    settingsNearbyLanHelp: 'A free, fast route when someone else in your chatroom is on your Wi-Fi. Stays silent while you are the only one in the chatroom.',
    settingsProviderOn: 'On',
    settingsProviderOff: 'Off',
    settingsProviderUnsupported: 'Not available on this phone',
    settingsProviderPermissionDenied: 'Permission needed — allow "Nearby devices" in Android settings',
    settingsProviderRadioOff: 'Turned off in Android — switch it on in quick settings',
    settingsNearbyStatusQuiet: 'No internet and nobody nearby yet — checking again in about {count} min.',
    settingsNearbyStatusBridging: 'Online — your phone links {count} nearby phone(s) without internet over Wi-Fi Direct to exchange talks.',
    settingsNearbyStatusBridgingJoined: 'Online — exchanging talks over Wi-Fi Direct with nearby phones that have no internet.',
    encounterLocationTitle: 'Encounter location',
    encounterLocationHelp: 'As a Traveler ✈, IinPublic never reads your GPS. Pick the place where you want to meet people — anywhere you like, even somewhere you are not. Only an approximate area around it is shared, never the point itself.',
    encounterLocationUnset: 'Not set — you only meet your contacts until you choose one.',
    encounterLocationRandomHelp: 'You are on the map at a random spot as a ✈ Traveler. Pick your own location so the right people nearby can find you.',
    encounterLocationSet: 'Set on {date} · stays on this device',
    encounterLocationSetButton: 'Set encounter location on map',
    encounterLocationChangeButton: 'Change encounter location',
    encounterLocationClearButton: 'Clear encounter location',
    encounterPickerTitle: 'Choose your encounter location',
    encounterPickerIntro: 'Tap the map where you want to meet people. It can be anywhere — it does not have to be where you are.',
    encounterPickerLatitude: 'Latitude',
    encounterPickerLongitude: 'Longitude',
    encounterPickerUseCurrent: 'Use my current location',
    encounterPickerLocating: 'Asking your browser for your location…',
    encounterPickerCurrentHint: 'Pin placed at your current location — move it if you like, then confirm.',
    encounterPickerCurrentFailed: 'Your browser could not provide a location. Tap the map instead.',
    encounterPickerMapFailed: 'The map could not load. You can still type coordinates.',
    encounterPickerDisclosure: 'Map tiles come from OpenFreeMap (OpenStreetMap data); the tile server sees which area you look at. Your chosen point is saved only on this device.',
    encounterPickerConfirm: 'Use this location',
    settingsNearbyWifiDirect: 'Connect phone-to-phone over Wi-Fi Direct',
    settingsNearbyWifiDirectHelp: 'Used when you or a nearby phone in your chatroom has no internet. Your phone links straight to nearby phones running IinPublic, without a router, so you can exchange talks even when one of you is offline. Turn off to stay invisible to nearby phones over Wi-Fi Direct.',
    settingsNearbyBluetooth: 'Use Bluetooth to notice nearby phones',
    settingsNearbyBluetoothHelp: 'Bluetooth only says "an IinPublic phone from your chatroom is here" so phones find each other faster. It listens in short bursts, less often while nobody is around. Talks never travel over Bluetooth. Off: phones still find each other over Wi-Fi, just more slowly.',
    settingsNearbyPrivacyTitle: 'What nearby people can and cannot see',
    settingsNearbyPrivacySameWifi: 'On the same Wi-Fi, IinPublic phones in the same chatroom find each other directly — like they would through the website.',
    settingsNearbyPrivacyOnlyOffline: 'Wi-Fi Direct links form only when a phone in your chatroom has no internet: offline phones link with each other and with online phones nearby, so they can still exchange talks. Every radio only finds people in your chatroom — never more than the chatroom allows.',
    settingsNearbyPrivacyEncrypted: 'Talks and messages stay signed and encrypted end to end. The phone that hosts the link passes them along but cannot read or change them.',
    settingsNearbyPrivacyVisible: 'Nearby phones running IinPublic can see that an IinPublic user is close by and can see the talks you share in a chatroom — the same as people in that chatroom online. Your name, profile and location are shared exactly as they are online, never more.',
    settingsNearbyPrivacyBluetooth: 'The Bluetooth signal carries no name and changes its code every 15 minutes, so it cannot be used to follow you.',
    settingsNearbyScreenOff: 'Always mode keeps the encrypted Talk mailbox and approved auto-answers running behind a persistent Android notification. Manufacturer battery savers can still delay or stop it; allow IinPublic unrestricted battery use for the most reliable delivery. While-open mode explicitly pauses exchange when the app page is frozen or closed.',
    settingsNearbyStatusStandby: 'Online — nearby mode is standing by.',
    settingsNearbyStatusOff: 'Wi-Fi Direct is off.',
    settingsNearbyStatusSearching: 'No internet — looking for IinPublic phones nearby…',
    settingsNearbyStatusHosting: 'No internet — your phone hosts a Wi-Fi Direct link for {count} nearby phone(s).',
    settingsNearbyStatusJoined: 'No internet — connected to nearby phones over Wi-Fi Direct.',
    settingsNearbyStatusLan: '{count} IinPublic phone(s) on this Wi-Fi.',
    nearbyOfflinePermissionDenied: 'No internet. Allow "Nearby devices" to find nearby phones — tap to open settings.',
    talksViewInMyAnswers: 'View in My Answers',
    talksDetailNotice: 'Talk: {title}',
    talksRemovedFromList: 'Talk removed from list',
    talksCompletedOutcome: 'Talk completed with outcome: {outcome}',
    talksAutoCaptured: 'Auto-talk captured! You can reuse this later.',
    talksCreateSyncSlow: 'Talk saved locally. Server is slow to sync - use Broadcast in the chatroom in a few seconds.',
    talksCreatedSent: 'Talk created and sent to chatroom!',
    talksCreatedSavedOnly: 'Talk saved to your list (send-to-room was off). Use Broadcast in Chatrooms when you want others to receive it.',
    talksCreatedNeedsRoom: 'Talk created. Open Chatrooms, join a room, then use Broadcast so others receive it.',
    talksCreateFailed: 'Failed to create talk: {reason}',
    talksUpdated: 'Talk updated.',
    talksUpdateFailed: 'Failed to update talk: {reason}',
    talksNotFound: 'Talk not found.',
    talksLoadFailed: 'Failed to load talk: {reason}',
    talksMatchNoticePrefix: 'Match!',
    talksMatchNotice: 'Match! {name} noticed you on "{title}"',
    talkTypeTag: 'Tag',
    talkTypeFlow: 'Flow',
    talkTypeSurvey: 'Survey',
    talkTypeRoute: 'Route',
    contextualStatsSummary: 'Stats: {responses} responses · {matches} matches · {rate}% match rate{room}',
    contextualStatsRoom: ' · top room {room}',
    contextualStatsHidden: 'hidden',
    contextualStatsEmpty: 'Stats: no data yet',
    repliesSearchPlaceholder: 'Stage name or talk',
    repliesAllOutcomes: 'All outcomes',
    repliesMatches: 'Matches',
    repliesMismatches: 'Mismatches',
    repliesIgnored: 'Ignored',
    repliesAutomatic: 'Automatic',
    repliesStrangers: 'Strangers',
    repliesAllTypes: 'All types',
    repliesAllLanguages: 'All languages',
    repliesNewestFirst: 'Newest first',
    repliesOldestFirst: 'Oldest first',
    repliesStageName: 'Stage name',
    repliesTalkTitle: 'Talk title',
    repliesRelationship: 'Relationship',
    repliesMatchesPerTalk: 'Matches per talk',
    repliesPerTalk: 'Replies per talk',
    repliesNoGrouping: 'No grouping',
    repliesGroupUser: 'Group by user',
    repliesGroupTalk: 'Group by talk',
    repliesGroupRelation: 'Group by relation',
    repliesGroupDay: 'Group by day',
    repliesUnavailable: 'Replies unavailable',
    repliesNoMatch: 'No replies match these filters.',
    repliesAnswers: 'Answers',
    repliesShowMore: 'Show',
    repliesScopedToTalk: 'Talk: {title}',
    repliesClearScope: 'Clear — show replies to all my talks',
    repliesViewContact: 'View contact',
    talksViewResponses: 'View Responses ({count})',
    contactsPromise: 'Find people through what matters to you.',
    contactsEmpty: 'Create or answer Talks, and compatible people will appear here.',
    contactsNoMatch: 'No contacts match these filters.',
    contactsOutcomeAll: 'All outcomes',
    contactsOutcomeMatched: 'Matched',
    contactsOutcomeUnmatched: 'Not matched',
    contactsPresenceAll: 'Online or not',
    contactsPresenceOnline: 'Online now',
    contactsLoading: 'Loading contacts...',
    contactsUnavailable: 'Could not load contacts.',
    contactsCountOne: '{count} contact from exchanged talks',
    contactsCount: '{count} contacts from exchanged talks',
    contactsTalkCountOne: '{count} talk',
    contactsTalkCount: '{count} talks',
    contactsMatchCountOne: '{count} match',
    contactsMatchCount: '{count} matches',
    contactsCommonTagCountOne: '{count} common tag',
    contactsCommonTagCount: '{count} common tags',
    contactsMatchRateDetail: '{matched}/{total} tags matched',
    contactsRankingExplanation: '{matches} matches x100 + {rate} rate + {relationship} relationship + {recency} recency',
    contactsBlocked: 'Blocked',
    contactsSupportPinned: 'Built-in',
    contactsSupportBuiltIn: 'Built-in support contact',
    contactsSupportOnline: 'Online',
    contactsSupportAway: 'Away',
    presenceOnline: 'Online',
    presenceAway: 'Away',
    contactNoRelationship: 'No relationship set',
    contactRelationshipCredit: 'Relationship & Credit',
    contactNickname: 'Nickname',
    contactCustomLabel: 'Custom label',
    contactCustomLabelHelp: 'Only used when relationship is custom',
    contactMyRating: 'My rating',
    contactNoRating: 'No rating',
    contactStar: 'star',
    contactStars: 'stars',
    contactPublicCredit: 'Public credit',
    contactProfileUnavailable: 'Profile unavailable.',
    contactCreditUnavailable: 'Could not load public credit.',
    contactCreditSummary: '{reviews} reviews · {friends} friends · {liked} liked · {disliked} disliked',
    contactCreditHidden: 'This user hides their credit section.',
    contactNotes: 'Notes',
    contactBlockStatus: 'Block status',
    contactBlockedBy: 'This user blocked you. Their profile and delivery surfaces are hidden.',
    contactBlockedByMe: 'You blocked this user. Talks will no longer be delivered between you.',
    contactNoBlock: 'No block is active.',
    contactVouchAdult: 'Vouch 18+',
    contactBlockUser: 'Block User',
    contactUnblockUser: 'Unblock User',
    contactAgeVoteSubmitted: 'Age verification vote submitted.',
    contactBlockedNotice: 'User blocked. Talk delivery is now disabled.',
    contactUnblockedNotice: 'User unblocked.',
    blockNotifyModalTitle: 'Notify your contacts?',
    blockNotifyModalBody: 'Privately let your contacts know you’ve blocked this person — no one else, including us, learns who reported it.',
    blockNotifySafetyResourceNote: 'If this involves a safety concern, NCMEC (report.cybertip.org) or your local police are better equipped to act than blocking alone.',
    blockNotifyPickGroup: 'Notify',
    blockNotifyPreview: '{count} people will be notified',
    blockNotifySkip: 'Skip',
    blockNotifyConfirm: 'Notify',
    contactCircleBlockWarning: '3 or more of your contacts have blocked this person',
    contactCircleBlockWarningTitle: 'A signal from your own contacts — not visible to anyone else',
    buildTrustTooltip: "Identifies whether this person's app build is officially signed — it says nothing about this person, their trustworthiness, or whether they're age-verified",
    buildTrustOfficialVerified: 'Official build',
    buildTrustOfficiallySignedUnavailable: 'Officially signed (device check unavailable)',
    buildTrustCommunityBuild: 'Community build',
    contactSupportControls: 'Support Notifications',
    contactSupportDescription: 'TechSupport remains available as your built-in support channel. Muting silences local notifications without removing it.',
    contactSupportNotificationStatus: 'Notification status',
    contactSupportNotificationsOn: 'Support notifications are on.',
    contactSupportNotificationsMuted: 'Support notifications are muted locally.',
    contactMuteSupport: 'Mute Support',
    contactUnmuteSupport: 'Unmute Support',
    contactSupportMutedNotice: 'TechSupport notifications muted on this device.',
    contactSupportUnmutedNotice: 'TechSupport notifications enabled on this device.',
    contactMatchToChat: 'Match with this user through Talks to start a conversation!',
    contactClose: 'Close',
    contactSave: 'Save',
    contactDetailsUnavailable: 'This user has blocked you. Details are not available.',
    contactNoTalks: 'No talks exchanged yet.',
    contactTalkFallback: 'Talk',
    contactCouldNotLoad: 'Could not load',
    contactCouldNotLoadTalks: 'Could not load talks.',
    contactSharedLanguage: '{language} (shared)',
    contactNoSharedLanguage: 'No shared profile language. Consider translation before messaging.',
    publicProfile: 'Public Profile',
    languagesLabel: 'Languages',
    interestsLabel: 'Interests',
    notListed: 'Not listed',
    noPublicProfile: 'No public profile attributes listed.',
    stranger: 'Stranger',
    sent: 'Sent',
    received: 'Received',
    relationship: 'Relationship',
    peerLoadingStats: 'Loading relationship stats...',
    peerLoadingHistory: 'Loading talk history...',
    peerTalkHistory: 'Talk History',
    peerLinkedIdentityBadge: '🔗 Linked identity',
    peerLinkedIdentityNote: 'You’ve verified this is one of your own linked identities. Contacts, blocks, reputation, conversations, and Q&A are not shared between linked identities.',
    peerDate: 'Date',
    peerOutcome: 'Outcome',
    peerAutoMode: 'Auto mode - send all new talks automatically',
    peerSendMyTalks: 'Send My Talks',
    peerSendDirectMessage: 'Send a direct message',
    peerMessagePlaceholder: 'Type a message...',
    peerSendMessage: 'Send Message',
    peerSending: 'Sending...',
    peerSentStatus: 'Sent',
    peerChannelStatus: 'Channel transport',
    transportStarGun: 'Star-compatible sync',
    transportServerRelay: 'Encrypted relay',
    transportDirectP2P: 'Direct P2P',
    transportFallbackReason: 'Fallback reason: {reason}',
    transportNoFallbackActive: 'No transport fallback is active.',
    transportNoFallbackReported: 'No fallback reason has been reported.',
    transportLastHealthyContact: 'Last confirmed contact: {time}',
    transportNoHealthyContact: 'No delivered message recorded yet.',
    peerProfileBlocked: 'This user blocked you. Detail view is unavailable.',
    peerBlockedDetail: 'Blocked users cannot view this detail surface.',
    peerStatsUnavailable: 'Could not load stats.',
    peerTalksExchanged: 'Talks Exchanged',
    peerMatchedCount: '{count} matched',
    peerNickname: 'Nickname',
    peerMutualMatches: 'Mutual Matches',
    peerMutualTags: 'Mutual Tags',
    peerStageName: 'Stage name: {name}',
    peerTalkExchangedOne: '{count} talk exchanged',
    peerTalksExchangedCount: '{count} talks exchanged',
    peerConversations: 'Matched talks ({count})',
    peerMessages: 'Messages',
    peerDirectMessages: 'Direct messages',
    peerTalkFallback: 'Talk',
    peerStartChatting: 'Start chatting...',
    peerAutoReplied: 'Auto-replied',
    peerOpenChat: 'Open Chat',
    peerHistoryUnavailable: 'Could not load history.',
    peerNoHistory: 'No talks exchanged yet.',
    peerMatch: 'Match',
    peerMismatch: 'Mismatch',
    peerPending: 'Pending',
    peerAllTalksSent: 'All talks already sent',
    peerSentTalkOne: 'Sent {count} talk',
    peerSentTalks: 'Sent {count} talks',
    talksChooseWhoToDm: 'Choose who to DM',
    dmInboxTitle: 'Direct Messages',
    dmInboxEmpty: 'No unread messages',
    peerNothingNewToSend: 'Nothing new to send',
    peerSendTalksTo: 'Send Talks to {name}',
    peerSelectTalks: 'Select talks to send:',
    peerSendUnavailableTitle: 'Unavailable to send',
    peerOmitAlreadySent: 'Already sent to this peer',
    peerNoEligibleTalks: 'No talks available to send',
    peerSentWithOmitted: 'Sent {sent}; {omitted} unavailable',
    peerSendSelected: 'Send Selected',
    conversationUser: 'User',
    conversationNoConversations: 'No conversations yet',
    conversationFindMatch: 'Match with someone through talks to start chatting!',
    conversationBotAnswered: 'Answered by chatbot',
    conversationUnknown: 'Unknown',
    conversationMatchedPreview: 'Matched! Start a conversation...',
    conversationStart: 'Start your conversation!',
    conversationMatchedStart: 'You matched! Start your conversation...',
    conversationMessagePlaceholder: 'Type a message...',
    conversationSend: 'Send',
    conversationTransport: 'Transport',
    captureConfirmTitle: 'Turn this into a Talk question?',
    captureConfirmHelp: 'This looks like a question with answer options. Send it as a tappable Talk question instead of plain text?',
    captureConfirmAccept: 'Yes, make it a Talk',
    captureConfirmDecline: 'No, just send as text',
    captureChipAnswered: 'Answered',
    captureTalkCreatedNotice: 'Saved as a new Talk in your Talks tab',
    captureTalkAppendedNotice: 'Added as a new question — the old version was updated',
    supportAutoAnswerPrefix: 'Auto-answer',
    supportNewQuestionAck: "Thanks, {name}. This is a new question — a human will get back to you here.",
    supportInboxTitle: 'Support inbox',
    supportInboxEmpty: 'No pending questions.',
    supportInboxQuestionLabel: 'Question (edit before publishing — this becomes public)',
    supportInboxPrivacyWarning: 'This question text will be public — remove any personal detail before publishing.',
    supportInboxAnswerLabel: 'Answer',
    supportInboxAnswerPublish: 'Answer & Publish',
    techSupportRecoveryBannerTitle: 'TechSupport recovery anchor active',
    supportDelegatesTitle: 'Delegates',
    supportDelegatesHelp: 'Let another account help answer support questions, without ever sharing your TechSupport key.',
    supportDelegatesUserIdLabel: 'Their user id',
    supportDelegatesLabelLabel: 'Label (e.g. "Alice\'s phone")',
    supportDelegatesTtlLabel: 'Expires after (days)',
    supportDelegatesIssue: 'Issue',
    supportDelegatesEmpty: 'No delegates issued yet.',
    supportDelegatesRevoke: 'Revoke',
    supportDelegatesRenew: 'Renew',
    supportDelegatesStatusActive: 'Active',
    supportDelegatesStatusRevoked: 'Revoked',
    supportDelegatesStatusExpired: 'Expired',
    supportDelegatesExpiresLabel: 'Expires {date}',
    supportDelegateActivityTitle: 'Delegate activity',
    supportDelegateActivityEmpty: 'No delegate-answered questions yet.',
    supportDelegateOptInTitle: 'Help answer TechSupport questions',
    supportDelegateOptInHelp: "TechSupport has asked you to help answer support questions. You'll answer with your own account — your name is never shown to the person asking.",
    supportDelegateOptInToggleLabel: 'Act as a TechSupport delegate',
    supportDelegatesInvite: 'Invite delegate',
    supportDelegatesInviteUser: 'Invite a user remotely',
    supportDelegatesInviteUserHelp: 'Send an invite to a specific person, wherever they are. Check the name and fingerprint before sending; they accept from their own Settings and their request still needs your approval.',
    supportDelegatesLookUp: 'Look up',
    supportDelegatesSendInvite: 'Send invite',
    supportDelegatesUnknownUser: 'No user with that ID was found.',
    supportDelegatesInviteSent: 'Invite sent. Their request will appear under Pending once they accept.',
    supportDelegateTargetedInviteTitle: 'TechSupport invited you to become a support delegate',
    supportDelegateTargetedInviteHelp: 'Accepting sends a signed request for review. Expires',
    supportDelegateTargetedInviteAccept: 'Accept',
    supportDelegateTargetedInviteDecline: 'Decline',
    supportDelegateTargetedInviteToast: 'TechSupport invited you to become a support delegate — see Settings.',
    supportDelegateInviteHelp: 'Generate a one-time code for the person you want to invite. They enter it in their own Settings to send a request — you still review and approve every request before it becomes a grant.',
    supportDelegateInviteCodeHelp: 'Share this code with the person you want to invite. It expires in 5 minutes.',
    supportDelegateInviteExpired: 'Code expired',
    supportDelegatesPendingTitle: 'Pending requests',
    supportDelegatesPendingEmpty: 'No pending requests.',
    supportDelegatesApprove: 'Approve',
    supportDelegatesRequestedLabel: 'Requested {date}',
    supportDelegateOptInEnterCode: 'I have an invite code',
    supportDelegateInviteEntryTitle: 'Become a support delegate',
    supportDelegateInviteEntryHelp: 'If TechSupport gave you an invite code, enter it here to request delegate access.',
    supportDelegateInviteEntrySubmit: 'Send request',
    supportDelegateInviteEntryPending: "Request sent. TechSupport will review it — you'll see an option to opt in here once approved.",
    supportDelegateInviteErrorInvalid: 'That code is invalid.',
    supportDelegateInviteErrorExpired: 'That code has expired.',
    supportDelegateInviteErrorUnavailable: 'Could not send the request. Try again.',
    supportDelegateGrantExpiringSoonSelf: 'Your TechSupport delegate access expires in {days} day(s).',
    supportDelegateGrantExpiringSoonOther: "{label}'s delegate access expires in {days} day(s) — renew?",
    locationSuggestedRoom: 'Suggested room: {room}',
    locationSuggestedRoomJoin: 'Join',
    supportChannelReady: '{name} support channel is ready.',
    matchChatReady: 'Match! You and {name} can now chat.',
    conversationNewMessage: 'New message from {name}',
    conversationAnswerFailed: 'Failed to process answer: {reason}',
    conversationNotInChatroom: 'Not in a chatroom.',
    conversationMessageSent: 'Message sent!',
    conversationSendFailed: 'Failed to send message: {reason}',
    mediaShareUploading: 'Uploading {name} to IPFS…',
    mediaShareBlockedRecipient: 'Cannot share media with a blocked user',
    attachmentDownload: 'Download',
    attachmentLoading: 'Loading… (fetching from sender)',
    mediaGalleryTitle: 'Shared ({count})',
    mediaGalleryEmpty: 'No photos or files shared in this conversation yet.',
    mediaLinksEmpty: 'No links shared in this conversation yet.',
    mediaTabMedia: 'Media',
    mediaTabFiles: 'Files',
    mediaTabLinks: 'Links',
    conversationLoadFailed: 'Failed to load conversation: {reason}',
    newTalkNotification: '📥 New talk from {name}: {title}',
    talksAutoAnsweredNotification: '🤖 Your chatbot answered {name}\'s talk: {title}',
    responseSubmittedFlow: "Response submitted! We'll notify you of matches.",
    responseSubmittedTag: 'Tag response submitted!',
    responseSubmittedSurvey: 'Survey response submitted! Thank you.',
    meNoAnswers: "Talks you've received and answered will appear here.",
    meAnswersIntro: "Talks you've received and answered, grouped by the same question set:",
    meSearchAnswers: 'Search answers',
    meAll: 'All',
    meAuto: 'Auto',
    meManualFilter: 'Manual',
    meConditional: 'Conditional',
    meTalkTypeFilters: 'Talk types',
    meTagStateFilters: 'Tag states',
    meTag: 'Tag',
    meQuestion: 'Question {count}',
    meAnsweredCount: 'Answered {count} time',
    meAnsweredCounts: 'Answered {count} times',
    meChoiceCount: 'choice count {count}',
    meChatbotGenerated: 'Chatbot-generated',
    mePermanent: 'Permanent',
    meManual: 'Manual',
    meAutoUsedCount: 'Auto-used {count} time',
    meAutoUsedCounts: 'Auto-used {count} times',
    meLatestAutoUse: 'Latest auto-use {date}',
    meContextHash: 'Context hash:',
    meContextPath: 'Context path:',
    meChecked: 'Checked',
    meUnchecked: 'Unchecked',
    meIndeterminate: 'Indeterminate',
    meNoMatchingAnswers: 'No recorded choices match these filters.',
    meItem: '{count} item',
    meItems: '{count} items',
    meWithinMile: 'Within {count} mile',
    meWithinMiles: 'Within {count} miles',
    meAnywhere: 'Anywhere',
    meFromSender: 'From {count} sender',
    meFromSenders: 'From {count} senders',
    meMostRecently: 'most recently {date}',
    meContextCount: '{count} context',
    meContextCounts: '{count} contexts',
    meContextIndicatorTitle: '{count} context(s) — tap for details',
    meUniversalAnswer: 'Same answer everywhere',
    meViewTalk: 'View talk',
    meViewContact: 'View contact',
    meActionLike: 'Like the selected tag (long-press a row to select it)',
    meActionPass: 'Pass the selected tag (long-press a row to select it)',
    meActionTalk: 'Open the Talk of the selected answer (long-press a row to select it)',
    meOpenTalk: 'Talk',
    meFilterLiked: 'Liked',
    meFilterPassed: 'Passed',
    mePeopleWhoExchanged: 'People who exchanged this with you',
    focusShowAll: 'Show all',
    meTalksWithQuestion: 'The Talks that asked this',
    contactsFilterTopic: 'Tag or question',
    placeMetHere: '{count} met here',
    placeTalksHere: '{count} Talks here',
    placeWhereExchanged: 'Where this was exchanged',
    peerMetIn: 'Met in',
    graphBack: 'Back to where you came from',
    listActionPin: 'Pin or unpin the selected row (long-press a row to select it)',
    contactsActionRemove: 'Remove the selected demo bot (long-press a row to select it)',
    meAnsweredVia: 'Answered via {type}',
    preferences: 'Preferences',
    preferencesAnswersTitle: 'My Answers',
    preferencesNoAnswers: 'No answered questions yet. When you answer a question, it will appear here and you can manage your preferences.',
    preferencesSummary: 'You have answered {count} question(s). You can change your answers and decide how each exact question is handled next time.',
    preferencesQuestionFallback: 'Question',
    preferencesLastAnswered: 'Last answered: {date}',
    preferencesUnavailable: 'N/A',
    preferencesYourAnswer: 'Your Answer:',
    preferencesOptionsUnavailable: '(Other options not available - answer this question again to enable editing)',
    preferencesMode: 'Mode:',
    preferencesAutoHelp: 'Auto mode will use this answer automatically next time',
    preferencesAutoBadge: 'AUTO',
    preferencesManualBadge: 'MANUAL',
    preferencesModeHelp: 'Auto uses the single scope selected in Settings. Manual asks you each time.',
    preferencesManualMode: 'Ask me every time',
    preferencesTemporaryMode: 'Same context and choices',
    preferencesWheneverMode: 'Whenever offered',
    preferencesPermanentMode: 'Permanent auto-answer',
    preferencesSuppressedMode: 'Skip this question',
    preferencesDelete: 'Delete',
    preferencesClearAll: 'Clear All Answers',
    preferencesClearConfirm: 'Are you sure you want to clear all saved answers?',
    preferencesAnswerUpdated: 'Answer updated',
    preferencesModeChangedAuto: 'Mode changed to AUTO',
    preferencesModeChangedManual: 'Mode changed to MANUAL',
    preferencesModeChangedTemporary: 'This choice will be reused only in the same context and choices',
    preferencesModeChangedWhenever: 'This answer is now your first preference whenever it is offered',
    preferencesModeChangedPermanent: 'Mode changed to PERMANENT auto-answer',
    preferencesModeChangedSuppressed: 'This question will be skipped automatically',
    preferencesAnswerDeleted: 'Answer deleted',
    preferencesAnswersCleared: 'All answers cleared',
    myTalksTitle: 'My Talks',
    myTalksEmpty: "You haven't created or answered any talks yet. Create or answer a talk to see it here.",
    myTalksSummary: 'You have {count} talk(s) in your history.',
    myTalksCreated: 'Created by me',
    myTalksCopied: 'Copied',
    myTalksAnswered: 'Answered by me',
    myTalksLastInteraction: 'Last interaction: {date}',
    myTalksId: 'Talk ID:',
    myTalksRemove: 'Remove from History',
    myTalksClear: 'Clear All History',
    myTalksClearConfirm: 'Are you sure you want to clear all talk history?',
    myTalksRemoved: 'Talk removed from history',
    myTalksCleared: 'All talk history cleared',
    copy: 'Copy',
    match: 'Match',
    mismatch: 'Mismatch',
    online: 'Online',
    editStageName: 'Edit Stage Name',
    editProfile: 'Edit Profile',
    stageDialogCurrent: 'Current: {name}',
    stageDialogNewName: 'New Stage Name',
    stageDialogPlaceholder: 'Enter your new stage name',
    stageDialogLength: '3-50 characters',
    stageDialogCancel: 'Cancel',
    stageDialogSave: 'Save',
    stageDialogUpdateFailed: 'Failed to update stage name. Please try again.',
    stageDialogTooShort: 'Stage name must be at least 3 characters long.',
    stageNameUpdated: 'Stage name updated successfully!',
    profileDialogDescription: 'Update profile basics. Q&A visibility controls what others see when they load your profile (contacts are people you add in Relationships).',
    profileDialogHeadshot: 'Headshot',
    profileDialogInterestPlaceholder: 'e.g. tennis, coffee, Hiking',
    profileDialogDefaultCategory: 'Default category for typed interests',
    profileDialogCategoryHelp: 'Known words (e.g. Hiking, Open to work) pick a category automatically; others use the default.',
    profileDialogAttributes: 'Profile Attributes',
    profileDialogQuestion: 'Question',
    profileDialogAnswer: 'Answer',
    profileDialogVisibilityTitle: 'Who can see this row on your public profile',
    profileDialogRemove: 'Remove',
    profileDialogAddAttribute: 'Add Attribute',
    profileDialogSave: 'Save Profile',
    profileDialogLanguageRequired: 'Please enter at least one language.',
    profileDialogUpdateFailed: 'Failed to update profile. Please try again.',
    profileUpdated: 'Profile updated successfully!',
    meVisibilityEveryone: 'Everyone',
    interestCategoryCommunity: 'Community',
    interestCategoryDiscussion: 'Discussion',
    interestCategoryPersonals: 'Personals',
    interestCategoryJobs: 'Jobs',
    interestCategoryGigs: 'Gigs',
    interestCategoryResumes: 'Resumes',
    interestCategoryForSale: 'For sale',
    interestCategoryHousing: 'Housing',
    interestCategoryServices: 'Services',
    interestCategoryOther: 'Other',
    profile: 'Profile',
    broadcastTagTrends: 'Broadcast tag trends',
    credit: 'Credit',
    showToOthers: 'Show to others',
    meProfileVisibilityHelp: 'Visibility per Q&A (see Edit Profile)',
    meNoPublicProfile: 'No public profile attributes yet.',
    meVisibilityContacts: 'Contacts only',
    meVisibilityPrivate: 'Just me',
    meTechSupportRole: 'Role',
    meTechSupportRoleValue: 'IinPublic network support',
    meTrendConnect: 'Connect to the app server to load broadcast tag trends.',
    meTrendNoData: 'No broadcast targeting data yet. Bulk sends with preamble tags populate this view.',
    meTrendTag: 'Tag',
    meTrendWindow: 'Window',
    meTrendDaily: 'Daily (UTC)',
    meTrendHelp: 'Rolling UTC day buckets for broadcast preamble tags (interest targeting).',
    meTrendUnavailable: 'Could not load broadcast tag trends.',
    meCreditHelp: "Your reputation is earned, not claimed. This read-only summary comes from other users' interactions.",
    meReviews: 'Reviews',
    meStarRating: 'Star rating',
    meFriends: 'Friends',
    meBlocks: 'Blocks received',
    meRoomCreationCredit: 'Custom-room eligibility',
    meRoomCreationUnlocked: 'Unlocked — you may create your one custom room.',
    meRoomCreationLocked: 'Locked — requires {requiredFriends} Friend marks and at most {maximumBlocks} blocks. Current: {friends} Friend marks, {blocks} blocks.',
    meLiked: 'Liked',
    meDisliked: 'Disliked',
    meMatches: 'Matches',
    meAgeVerified: 'Age verified',
    talkTemplatePickerTitle: 'Start a Talk',
    talkTemplatePickerSubtitle: 'Pick a template to start from — every field stays fully editable — or build your own from scratch.',
    talkTemplateScratch: 'Start from scratch',
    talkTemplateScratchDesc: 'Build a talk with a blank editor.',
    talkTemplateSharedInterest: 'Shared Interest',
    talkTemplateSharedInterestDesc: 'Find people who are interested in the same thing.',
    talkTemplateActivityMeetup: 'Activity / Meetup',
    talkTemplateActivityMeetupDesc: 'Invite people to join an activity and find a workable time.',
    talkTemplateQuickPoll: 'Quick Community Poll',
    talkTemplateQuickPollDesc: 'Ask one practical question and collect the community’s choices.',
    talkTemplateBuySell: 'Buy / Sell',
    talkTemplateBuySellDesc: "A two-sided marketplace offer — declare what you're buying or selling.",
    talkTemplateTaxi: 'Taxi Ride',
    talkTemplateTaxiDesc: 'Match a passenger with a driver, right now.',
    talkTemplateJob: 'Job Seeker / Hiring',
    talkTemplateJobDesc: 'Match a job seeker with someone hiring.',
    talkTemplateDating: 'Dating',
    talkTemplateDatingDesc: 'A mutual age-range dating match. Adult content (18+) only.',
    talkTemplateRoommate: 'Roommate Search',
    talkTemplateRoommateDesc: 'Match someone who needs a roommate with someone who has a room.',
    talkTemplateLostFound: 'Lost & Found',
    talkTemplateLostFoundDesc: 'Reunite a lost item with whoever found it.',
    talkTemplatePetSitting: 'Pet Sitting',
    talkTemplatePetSittingDesc: 'Match someone who needs a pet sitter with someone offering to sit.',
    talkTemplateTutor: 'Study Buddy / Tutoring',
    talkTemplateTutorDesc: 'Match someone who needs a tutor with someone offering to tutor.',
    talksStarterTitle: 'Starter Talks',
    talksAnsweredByChatbot: 'Answered automatically by your chatbot',
    talksStarterBody: 'Use the Tags that fit you and drop the rest. You can edit anything you keep.',
    talksStarterMore: 'Build from a template',
    talksStarterScratch: 'Build from scratch',
    starterTalkUse: 'Use',
    starterTalkDrop: 'Drop',
    starterTalkSimpleTag: 'Tag',
    starterTalkPairTag: 'Pair tag',
    starterTalkPairAccepts: 'Pairs with: {answer}',
    starterContactDemoBadge: 'Demo bot',
    tagDirectoryTitle: 'Tags',
    starterCreatePromptTitle: 'Something more specific?',
    starterCreatePromptBody: 'A tag only a few people share is the best way to find your people. Create your own; the Tag Guide below shows how.',
    starterCreatePromptAction: '＋ Create my tag',
    tagDirectorySearch: 'Find a tag',
    tagDirectoryEmpty: 'No tags yet. Like a few on the Talks tab.',
    tagPagePeopleCount: '{count} people like this',
    tagPageInMyTags: 'In your tags',
    tagPageNotInMyTags: 'Not in your tags',
    tagPageNobody: 'Nobody you have exchanged Talks with likes this yet.',
    tagsInCommon: '{count} in common',
    peerTagsTitle: 'Tags',
    contactsSortSharedTags: 'Most tags in common',
    settingsContactsCap: 'Keep up to this many people you have only exchanged Talks with',
    settingsContactsCapHelp: 'Beyond it, the ones you share the fewest tags with and met longest ago leave Contacts. People you messaged, marked, labeled, pinned or blocked always stay.',
    starterContactRemove: 'Remove',
    editorBrowseTemplates: '🎨 Start from a template',
    editorCreateTitle: 'Create a Talk',
    editorEditTitle: 'Edit Talk',
    editorPromise: 'Write conversations, not code.',
    editorDescription: 'Build a branching conversation flow - each answer can lead to a different question',
    editorTagDescription: 'Tag: one keyword. Others answer directly with Like or Pass.',
    editorTalkTitle: 'Talk Title',
    editorLanguage: 'Language',
    editorType: 'Type',
    editorTagTypeName: 'Tag',
    editorFlowTypeName: 'Flow',
    editorSurveyTypeName: 'Survey',
    editorRouteTypeName: 'Route',
    editorMoreOptions: 'More options',
    editorTagPairLabel: 'What is this? (optional)',
    editorTagPairPlaceholder: 'e.g. buy, sell, hiring, jobseeking',
    editorTagPairOppositeLabel: 'Shown to people tagged:',
    editorTagPairNoOpposite: "Matches anyone also tagged '{tag}'.",
    editorPreviewToggle: '👁 Preview: what the responder sees',
    editorPreviewEmpty: 'Fill in a question to see the preview.',
    editorPreviewMatchResult: '✅ This would be a match.',
    editorPreviewIgnoreResult: '❌ This would be filtered out (ignored).',
    editorPreviewSurveyComplete: 'Survey complete — thanks!',
    editorPreviewRestart: '↺ Restart preview',
    editorRoleLabel: 'Role in this deal (optional)',
    editorRoleNone: 'No role',
    editorRoleOffer: 'Offering (I have or provide something)',
    editorRoleRequest: 'Requesting (I want or need something)',
    editorRoleHelp: 'Two talks with the SAME role never match (e.g. two buyers) — only opposite roles can.',
    editorQuestions: 'Questions & Branching',
    editorAddQuestion: '+ Add Question',
    editorExpiration: 'Expiration',
    editorLocation: 'Location',
    editorSendChatroom: 'Send to Chatroom',
    editorAdult: 'Adult content (18+) - only delivered to age-verified users',
    editorAttachment: 'Attach media (link shared automatically when someone matches)',
    editorExistingAttachment: 'Photo to share when matched',
    editorCancel: 'Cancel',
    editorCreate: 'Create',
    editorSave: 'Save changes',
    editorTitlePlaceholder: 'e.g., Coffee Meetup, Quick Survey',
    editorTagPlaceholder: 'e.g., Coffee, Tennis, Jobs',
    editorTagKeyword: 'Tag keyword',
    editorTagLike: 'I like this tag',
    editorTagOption: 'Tag (single keyword; answer directly with Like or Pass)',
    editorFlowOption: 'Flow - sequential questions that find compatible people',
    editorSurveyOption: 'Survey - independent questions that collect aggregate counts',
    editorRouteOption: 'Route - branching DAG of questions (tree editor)',
    editorRouteTitle: 'Route (DAG editor)',
    editorRouteHelp: 'Build a branching tree. Each answer can lead to a follow-up question. On any path from root to leaf, the same question cannot appear twice; it may appear in separate branches with separate context ids.',
    editorRouteKindMatch: 'Match',
    editorRouteKindIgnore: 'Ignore',
    editorRouteKindTerminal: 'Terminal',
    editorRouteKindLink: 'Next question',
    editorRouteQuestionPrefix: 'Q:',
    editorRouteQuestionPlaceholder: 'Question (end with ?)',
    editorRouteAnswerPlaceholder: 'Answer text (e.g., Yes.)',
    editorRouteAddChild: '+ Child Q',
    editorRouteAddParallel: '+ Parallel Q',
    editorRouteParallelThresholdLabel: 'Match at least ___ of {count} (blank = all):',
    editorRouteParallelThresholdAll: 'all',
    editorRouteRemoveQuestion: 'Remove Q',
    editorRouteDefaultMatch: 'Match.',
    editorRouteNewAnswer: 'New answer.',
    editorRouteRequired: 'Route must have at least one question',
    editorTagRequired: 'Tag keyword is required',
    editorFinancialDataBlocked:
      'Remove payment card numbers or other financial/banking details before saving — IinPublic is for talk exchange only, never for financial transactions.',
    editorCannotSave: 'Cannot save - please fix:',
    editorAutoFixed: 'Auto-fixed:',
    editorForever: 'Forever',
    editorOneYear: 'One year',
    editorOneMonth: 'One month',
    editorOneWeek: 'One week',
    editorOneDay: 'One day',
    editorAnywhere: 'Anywhere',
    editorMiles: '{count} miles',
    editorRouteDescription: 'Route: a branching DAG. Each answer can lead to a follow-up question; the same question can appear in different branches with different context ids.',
    editorSurveyQuestions: 'Questions (independent)',
    editorSurveyHint: 'Survey: questions are independent - no branching. Every answer has a counter used for aggregate statistics.',
    editorSurveyDescription: 'Survey: independent question and answer pairs. Counts per answer are tallied for statistics.',
    editorFlowQuestions: 'Questions (flow)',
    editorFlowHint: 'Flow: each question must be unique. The first answer is your match or next-question decision; extra answers are treated as ignore.',
    editorFlowDescription: 'Flow: a linear chain of unique questions - the first answer decides and the rest are ignored.',
    editorFlowConstraint: 'Flow talks: only the first answer decides; other answers are normalized to Ignore when you save.',
    editorQuestionNumber: 'Question {count}',
    editorAnswerPlaceholder: 'Answer {count}',
    editorMyAnswer: 'My answer',
    editorIgnore: 'Ignore',
    editorIgnoreFilter: 'Ignore (filter out)',
    editorNoticed: 'Noticed (match)',
    editorGoToQuestion: 'Go to Question {count}',
    editorQuestionPlaceholder: 'Enter your question here (e.g., Do you like coffee?)',
    editorAddAnswer: '+ Add Answer',
    editorAdvancedToggle: 'Advanced options',
    editorAnswerSelectionModeLabel: 'Respondent may select:',
    editorAnswerSelectionModeSingle: 'One (multiple choice)',
    editorAnswerSelectionModeMultiple: 'Any that apply (checkboxes)',
    editorSimpleTagLabel: 'Simple tag (answer must match the question itself — needs exactly 1 real answer, besides Ignore)',
    editorReciprocalTagLabel: 'Pair tag — define buy/sell context here for later questions (needs exactly 1 real answer, besides Ignore)',
    editorBuiltInKindLabel: 'Compare using:',
    editorBuiltInKindNone: 'Ordinary answer choices',
    editorBuiltInKindQuantity: 'Quantity (number comparison)',
    editorBuiltInKindPriceRange: 'Price range (overlap)',
    editorBuiltInKindTimeFrame: 'Time frame (date overlap)',
    editorBuiltInKindLocation: 'Location (radius match)',
    editorBuiltInKindAgeRange: 'Age range (mutual dating match)',
    editorBuiltInQuantityLabel: 'Quantity:',
    editorBuiltInPriceMinLabel: 'Min price:',
    editorBuiltInPriceMaxLabel: 'Max price:',
    editorBuiltInTimeStartLabel: 'From:',
    editorBuiltInTimeEndLabel: 'To:',
    editorBuiltInLocationNote: "Uses this talk's own location and radius (set below).",
    editorBuiltInAgeLabel: 'My age:',
    editorBuiltInAgeMinLabel: 'Acceptable age, min:',
    editorBuiltInAgeMaxLabel: 'Acceptable age, max:',
    editorBuiltInQuantityRequired: 'Enter a quantity for the built-in comparison question.',
    editorBuiltInPriceRangeRequired: 'Enter a valid min/max price range for the built-in comparison question.',
    editorBuiltInTimeFrameRequired: 'Enter a valid date range for the built-in comparison question.',
    editorBuiltInAgeRangeRequired: 'Enter your age and a valid min/max acceptable partner age range.',
    editorRemove: 'Remove',
    responseTagHelp: 'Check the tag if it describes you',
    responseInterested: "Match (I'm interested)",
    responseSubmit: 'Submit',
    responseSelectAtLeastOne: 'Select at least one option.',
    responseQuestion: 'Question',
    responseAnswer: 'Answer',
    responseOf: 'of',
    responsePrevious: 'Previous question',
    responseProgress: 'Response progress',
    responseEstimateMinute: '~{count} min',
    responseEstimateMinutes: '~{count} min',
    responseRouteLeadsTo: 'This leads to: {question}',
    responseRouteLeadsToMatch: 'This leads to a match',
    responseRouteLeadsToIgnore: 'This ends this route',
    responseRouteLeadsToEnd: 'This ends this route',
    responseRouteChange: 'Change',
    responseRouteContinue: 'Continue',
    responseClose: 'Close response',
    responseRememberAs: 'Remember as',
    responseAuto: 'Auto',
    responseWhenever: 'Whenever offered',
    responseManual: 'Manual',
    responsePermanent: 'Permanent',
    responseIgnore: 'Ignore',
    responseInvalidTag: 'Invalid tag',
    responseMissingQuestions: 'Could not load talk (missing questions).',
    responseMatch: 'Match! You both noticed each other.',
    responseMatchAuto: 'Match! You both noticed each other. (auto)',
    responseTagIgnored: 'Tag ignored - no match',
    responseTalkIgnored: 'Talk ignored - no match',
    responseTalkIgnoredAuto: 'Talk ignored - no match (auto)',
    refreshLocation: 'Refresh Location',
    settingsStageName: 'Stage name',
    settingsHeadshot: 'Headshot',
    settingsInitial: 'Initial',
    settingsChoosePhoto: 'Choose Photo',
    settingsTakePhoto: 'Take Photo',
    settingsRemove: 'Remove',
    settingsPhotoHelp: 'Any photo works — it is resized automatically. Profile photos are public.',
    settingsPhotoPreviewTitle: 'Preview Profile Photo',
    settingsPhotoPreviewHelp: 'This photo will be visible on your public profile after you confirm.',
    settingsPhotoPreviewCancel: 'Cancel',
    settingsPhotoPreviewSave: 'Use Photo',
    settingsCameraCaptureTitle: 'Take Profile Photo',
    settingsCameraCaptureHelp: 'Position yourself in the frame, then capture a preview.',
    settingsCameraCapture: 'Capture',
    settingsCameraUnavailable: 'Camera capture is unavailable on this device. Choose a photo instead.',
    settingsCameraDenied: 'Camera access was denied. Choose a photo instead or allow camera access.',
    settingsDistanceInvalid: 'Minimum distance cannot be greater than maximum distance.',
    settingsStageNameTooShort: 'Stage name must be at least 3 characters.',
    settingsStageNameReserved: 'That stage name is reserved. Please choose another name.',
    settingsStageNameUpdateFailed: 'Stage name could not be updated.',
    settingsPhotoInvalidType: 'That file is not an image this device can read.',
    settingsPhotoTooLarge: 'That photo file is too large to process.',
    settingsPhotoReadFailed: 'Photo could not be read.',
    settingsAppearance: 'Appearance',
    settingsAppearanceHelp: 'Choose a color scheme for the whole app.',
    schemeGoldenHour: 'Golden Hour',
    schemeTropicalForest: 'Tropical Forest',
    schemeSnowMountain: 'Snow Mountain Skiing',
    schemeBeachSunset: 'Beach Sunset',
    appDownloadBannerText: "You're using the web version.",
    appDownloadBannerGetApp: 'Get the {platform} app',
    appDownloadBannerSeeOptions: 'See download options',
    appDownloadBannerDismiss: 'Dismiss',
    appUpdateReminderText: 'IinPublic {version} is available.',
    appUpdateReminderGetUpdate: 'Update',
    p2pVersionMismatchOlderReminder: "A contact is on IinPublic {remoteVersion}, newer than your {localVersion} — update the app to stay compatible with new features.",
    p2pVersionMismatchNewerReminder: "You're on IinPublic {localVersion}, newer than this contact's {remoteVersion} — some newer features may not work with them yet.",
    settingsDownloadApp: 'Download the app',
    settingsDownloadAppSubtitle: 'Native apps for Mac, Windows, and Android.',
    settingsDownloadAppComingSoon: 'Coming soon',
    settingsLanguages: 'Languages',
    settingsUiLanguage: 'App language',
    settingsProfileLanguage: 'Profile language',
    settingsDefaultTalkLanguage: 'Default talk language',
    settingsIncomingLanguage: 'Incoming talk language filter',
    settingsActive: 'active',
    settingsTalkBehavior: 'Talk Behavior',
    settingsCopyTalk: 'Keep a copy of tags I accept',
    settingsChatbot: 'Enable chatbot',
    settingsChatbotHelp: 'Teach it once. One answer can power hundreds of conversations. Your chatbot repeats you—not invents you.',
    settingsAutoAnswerScope: 'Auto answer scope',
    settingsAutoAnswerScopeHelp: 'This one setting applies to every answer you mark Auto.',
    settingsAutoAnswerSameContext: 'Same context',
    settingsAutoAnswerWhenever: 'Whenever offered',
    settingsLocationAutoMatch: 'Let the chatbot auto-match using my approximate (blurred) location',
    settingsLocationAutoMatchNote: 'Only your approximate location is ever used automatically. Your precise location is never sent without you personally choosing to share it.',
    settingsKeepOldTalkOnEdit: 'Keep old talk versions when editing (advanced — default is to remove the old version)',
    settingsDistanceHome: 'Distance and Home',
    settingsMinDistance: 'Min distance (miles)',
    settingsMaxDistance: 'Max distance (miles)',
    settingsSentAfter: 'Only talks sent after',
    settingsHomeRoom: 'Home room',
    settingsLocation: 'Location',
    settingsUnknown: 'Unknown',
    settingsContentFilters: 'Content Filters',
    settingsContentFiltersHelp: 'Speak freely. Own what you say. Choose what reaches you.',
    settingsContactsOnlyTalks: 'Only exchange Talks with contacts',
    settingsContactsOnlyTalksHelp: 'Do not send your Talks to strangers, and ignore Talks or Talk responses from them. You can still see people in chatrooms and nearby.',
    settingsMessageFiltersHeading: 'Message filters',
    settingsFilteredIncomingHeading: 'Filtered incoming',
    settingsGrammar: 'Grammar filter',
    settingsGrammarHelp: 'Checks titles and question prompts for readable sentence length, punctuation, and heavy repetition.',
    settingsGrammarStrictness: 'Applies to talks and messages; strictness {threshold} (fixed).',
    settingsDirtyWords: 'Dirty words filter',
    settingsDirtyWordsHelp: 'Checks title, questions, and answer choices against an English and Chinese moderation list.',
    settingsDirtyWordsListLabel: 'Blocked words',
    settingsDirtyWordsListHelp: 'Applies to talks and to your direct messages, in both directions. Built-in spam terms always apply.',
    settingsDirtyWordAddPlaceholder: 'Add a word',
    settingsDirtyWordAdd: 'Add',
    settingsDirtyWordReset: 'Reset to defaults',
    settingsDirtyWordTooShort: 'Word must be at least 2 characters.',
    settingsDirtyWordDuplicate: 'That word is already in the list.',
    settingsDirtyWordLimit: 'You can have at most 50 words.',
    messageBlockedDirtyWord: 'Message not sent: contains a blocked word',
    messageBlockedGrammar: 'Message not sent: failed the grammar check',
    messageBlockedFinancialData: 'Not sent: looks like payment/financial details. IinPublic is for talk exchange only.',
    messageHiddenDirtyWord: 'A message was hidden by your dirty-word filter',
    messageHiddenGrammar: 'A message was hidden by your grammar filter',
    messageHiddenPlaceholder: 'message hidden by your filters',
    safetyToastPreSend: 'IinPublic is for talk exchange only. Never share payment card numbers or send money through this app.',
    safetyToastPostMatch: "You've matched. Never send money through this app — pay in person if you complete a deal. If you're meeting for the first time, choose a public place.",
    settingsLinkedDevices: 'Linked devices',
    settingsLinkedDevicesHelp: 'Manage direct links between independently keyed identities.',
    settingsIdentityDevices: 'Identity & devices',
    settingsIdentityDevicesHelp: 'Inspect this device\'s identity, local protection, name, and direct identity links.',
    settingsOwnershipPromise: 'Your identity. Your answers. Your data.',
    settingsGroupPersonalization: 'Personalization',
    settingsGroupTalksDiscovery: 'Talks & discovery',
    settingsGroupIdentityTrust: 'Identity & trust',
    settingsGroupAppData: 'App & data',
    settingsGroupSupport: 'Support',
    settingsManage: 'Manage',
    linkedDeviceDefaultName: 'Linked device',
    identityDevicesTitle: 'Identity & devices',
    identityCardTitle: 'Your identity',
    identityFingerprintLabel: 'Identity fingerprint',
    identityStatusAvailable: 'Available on this device',
    identityStatusLocked: 'Locked',
    identityStatusNeedsAttention: 'Needs attention',
    identityStoredLocally: 'This identity is stored on this device. IinPublic does not keep an account copy on a server.',
    copyFullIdentityId: 'Copy full identity ID',
    identityIdCopied: 'Identity ID copied.',
    identityIdCopyFailed: 'Could not copy the identity ID.',
    identityProtectionTitle: 'Identity protection',
    identityPasswordNotSet: 'Identity password: Not set',
    identityPasswordSet: 'Identity password: Set',
    identityOpensAutomatically: 'IinPublic opens automatically on this device.',
    identityPasswordPlanned: 'Optional password protection will be added after its custody design is security-reviewed.',
    identityUnlockedThisSession: 'Unlocked for this session. Reloading or locking requires the password again.',
    setIdentityPassword: 'Set identity password',
    changeIdentityPassword: 'Change identity password',
    removeIdentityPassword: 'Remove identity password',
    lockIdentityNow: 'Lock now',
    identityUnlockTitle: 'Unlock your identity',
    identityUnlockHelp: 'Enter the local identity password for this device.',
    identityPasswordLabel: 'Identity password',
    showPassword: 'Show password',
    unlockIdentity: 'Unlock identity',
    unlockingIdentity: 'Unlocking…',
    identityUnlockFailed: 'Could not unlock. Check the password and try again.',
    forgotIdentityPassword: "Why can't this password be reset?",
    identityPasswordNoReset: 'IinPublic cannot reset this password. If you forgot it, the only option on this device is to erase local data and start over with a different identity.',
    eraseAndStartOver: 'Erase and start over',
    identityPasswordPermanentWarning: "IinPublic does not store your password or identity on a recovery server. No one—including IinPublic—can recover or reset this password. If you forget it, this device's identity and local encrypted data may become permanently inaccessible. A linked device cannot unlock this one. You can erase this device and start over, but that will not recover the old identity.",
    newIdentityPassword: 'New identity password',
    confirmIdentityPassword: 'Confirm identity password',
    currentIdentityPassword: 'Current identity password',
    identityPasswordStrengthGuidance: 'Use at least 15 characters. Spaces and any language are allowed.',
    identityPasswordWarningAck: 'I understand that this password cannot be recovered or reset',
    identityPasswordAcknowledgeRequired: 'Acknowledge the no-reset warning first.',
    identityPasswordMismatch: 'The passwords do not match.',
    identityPasswordTooShort: 'Use at least 15 characters.',
    identityPasswordSetFailed: 'Could not set the identity password. Your existing identity was not changed.',
    identityPasswordChangeFailed: 'Could not change the password. Check the current password and try again.',
    removeIdentityPasswordWarning: "Removing your password makes this identity open automatically on this device. Browser storage will contain everything needed to unlock it. Anyone who can copy or access this browser's local data may be able to use your identity. This does not delete your identity or data.",
    removeIdentityPasswordAck: 'I understand that removing the password reduces protection on this device.',
    identityPasswordRemoveFailed: 'Could not remove the password. Check the current password and try again.',
    setPassword: 'Set password',
    changePassword: 'Change password',
    removePassword: 'Remove password',
    thisDeviceTitle: 'This device',
    thisDeviceBadge: 'This device',
    identityCreatedLabel: 'Identity created',
    deviceProtectionAutomatic: 'Protection: automatic',
    deviceProtectionPassword: 'Protection: identity password',
    renameDevice: 'Rename device',
    deviceNameLabel: 'Device name',
    deviceNameRequired: 'Enter a device name.',
    defaultAndroidDeviceName: 'This Android device',
    defaultIosDeviceName: 'This iOS device',
    defaultDesktopDeviceName: 'This desktop app',
    defaultBrowserDeviceName: 'This browser',
    linkedDevicesTitle: 'Linked devices',
    linkedDevicesEmpty: 'No linked devices',
    linkedDevicesEmptyHelp: 'Link another device you control. Private keys stay on the device that created them.',
    linkedDevicesNoTransfer: 'A direct link does not authorize data transfer, synchronization, recovery, or merged authorship.',
    linkedDeviceStateWaiting: 'Waiting for approval',
    linkedDeviceStateLinked: 'Linked',
    linkedDeviceStateRevocationPending: 'Revocation pending',
    linkedDeviceStateRemoved: 'Removed',
    linkedDeviceStateInvalid: 'Invalid',
    linkedDeviceStateConflicted: 'Conflicted — review required',
    deviceSyncEnable: 'Enable sync',
    deviceSyncPending: 'Sync pending…',
    deviceSyncActive: 'Syncing',
    deviceSyncConflictsTitle: 'Choose which changes to keep',
    deviceSyncConflictsHelp: 'These records changed in ways that cannot be merged safely. Review every item. Private contents are not shown on this summary screen.',
    deviceSyncConflictVersions: 'This device',
    deviceSyncOtherDevice: 'Other device',
    deviceSyncKeepLocal: 'Keep this device’s version',
    deviceSyncUseIncoming: 'Use the other device’s version',
    deviceSyncApplyChoices: 'Apply choices',
    deviceSyncChooseEveryConflict: 'Choose an option for every conflict.',
    linkADevice: 'Link a device',
    generateLinkCode: 'Generate code',
    linkPublicCorrelationWarning: 'Linking can publicly reveal that two pseudonymous identities are controlled together. Removing the link later cannot erase copies of the earlier signed relationship.',
    linkPeerPreview: 'Identity fingerprint',
    approveAndLink: 'Approve and link',
    enterLinkCode: 'Enter or scan a code',
    linkCodeHelp: 'Enter this code on your other device before it expires.',
    linkQrPlaceholderLabel: 'QR code containing this pairing code',
    linkQrCodeLabel: 'QR code containing this pairing code',
    linkQrRenderFailed: 'Could not render QR code. Use Copy instead.',
    scanLinkCode: 'Scan with camera',
    cameraPermissionPrompt: 'Allow camera access to scan the QR code.',
    cameraScanningQr: 'Point the camera at the QR code.',
    linkCodeScanned: 'Code scanned. Review it, then press Link.',
    cameraScanFailed: 'Camera scanning is unavailable. Paste the code instead.',
    linkCodeTimeRemaining: 'Link code time remaining',
    linkCodeInputLabel: 'Link code',
    linkCodeExpired: 'Code expired',
    refreshLinkStatus: 'Refresh status',
    checkForLinkRequest: 'Check for request',
    checkingForLinkRequest: 'Checking…',
    linkWaitingForOtherDevice: 'Waiting for the other device to enter this code.',
    linkApprovalPrompt: 'Approve a direct identity link with',
    approveLinkRequest: 'Approve link',
    linkApprovalFailed: 'Could not verify and approve this request.',
    linkApprovalComplete: 'Direct identity link verified.',
    linkCodePlaceholder: 'Paste link code',
    pasteFromClipboard: 'Paste',
    copyLink: 'Copy link',
    shareLinkCode: 'Share…',
    shareLinkCodeMessage: 'Open this link on your other device, or enter the code in Settings → Identity & devices:',
    shareLinkCodeCopied: 'Copied — paste it into any app to send it to your other device.',
    linkWithAppOnThisComputer: 'Link with the app on this computer',
    linkErrorInvalid: 'That code is invalid.',
    linkErrorExpired: 'That code has expired.',
    linkErrorReused: 'That identity is already linked.',
    linkErrorSelf: 'You cannot link an identity to itself.',
    linkErrorUnavailable: 'Could not reach the public graph. Try again.',
    unlinkTitle: 'Remove link',
    unlinkConfirm: 'Remove the link to',
    unlinkConsequences: 'This stops future trust through this link. It does not erase that device, delete its local data, recall public records, or hide the earlier relationship.',
    removeLink: 'Remove link',
    unlink: 'Unlink',
    retryRevocation: 'Retry revocation',
    done: 'Done',
    cancel: 'Cancel',
    save: 'Save',
    close: 'Close',
    link: 'Link',
    settingsEraseDevice: 'Erase this device',
    settingsEraseDeviceHelp: 'Remove your identity and all data from this computer (for shared/public PCs).',
    settingsHelp: 'Help & Tour',
    settingsHelpSubtitle: 'Review your starter Talks or replay the product introduction.',
    settingsStartGuide: 'Build my digital you',
    settingsReplayWalkthrough: 'How IinPublic works',
    settingsHelpFaqHeading: 'Frequently asked questions',
    walkthroughSkip: 'Skip',
    walkthroughBack: 'Back',
    walkthroughNext: 'Next',
    walkthroughDone: 'Get started',
    walkthroughProgress: '{current} of {total}',
    walkthroughWelcomeTitle: 'Build your digital you',
    walkthroughWelcomeTagline: 'Say it once. Let your digital you repeat it.',
    walkthroughWelcomeBody: 'Ask or answer once. Your digital you will automatically reuse your questions and approved answers when they fit.',
    walkthroughWelcomeNoLogin: 'You decide which of your questions and answers can be reused.',
    walkthroughWelcomeResponsibility: "You only need to handle what's new.",
    walkthroughChatroomsTitle: 'Chatrooms',
    walkthroughChatroomsTagline: "What's being talked about around me?",
    walkthroughChatroomsBody: 'Join a room by location or topic and meet people nearby.',
    walkthroughChatroomsBroadcast: 'Broadcast your Talks to people in the room.',
    walkthroughChatroomsReceive: "Receive others' Talks from the room.",
    walkthroughChatroomsNearby: 'Find people nearby—with Internet or supported direct connections.',
    walkthroughChatroomsOneToOne: 'Chatrooms help you discover people. Conversations stay one-to-one.',
    walkthroughTalksTitle: 'Talks',
    walkthroughTalksTagline: 'Create questions for your digital you to ask on your behalf.',
    walkthroughTalksBody: 'Create and answer questions in one place—no programming needed.',
    walkthroughTalksAnswerOwn: 'Answer your own questions to share what you think.',
    walkthroughTalksAnswerOthers: 'Respond to questions you receive from others.',
    walkthroughTalksChatbotRepeat: 'Your digital you repeats approved answers—it does not invent them.',
    walkthroughTalksReuse: 'Create once. Save, share, and reuse.',
    walkthroughTalksOnlyNew: "You only need to handle what's new.",
    walkthroughContactsTitle: 'Contacts',
    walkthroughContactsTagline: 'Turn common ground into a real connection.',
    walkthroughContactsBody: "When you and someone else answer a talk compatibly, that's a match — find them here and start chatting.",
    walkthroughContactsScale: 'Find compatible people without hundreds of one-to-one searches.',
    walkthroughMeTitle: 'Me',
    walkthroughMeTagline: 'Build your digital you, one answer at a time.',
    walkthroughMeBody: 'Your public image grows from what you ask, answer, create, and contribute—not just from a self-written bio.',
    walkthroughMeIdentity: 'Who am I? A public record of the questions and answers you choose to share.',
    walkthroughMeStory: 'Your answers tell your story. Review or change them any time.',
    walkthroughSettingsTitle: 'Settings',
    walkthroughSettingsTagline: 'Your app. Your boundaries.',
    walkthroughSettingsBody: 'Tune filters, appearance, and privacy — and you can replay this tour any time from Settings → Help & Tour.',
    walkthroughSettingsData: 'Your identity and private data stay under your control—not under a single server.',
    walkthroughSettingsReputation: 'Your reputation is earned from others. You decide how much to show.',
    walkthroughSettingsBoundaries: 'Choose what reaches you. Block who can reach you. Everyone else has the same control.',
    settingsCreditVisible: 'Show reputation/credit',
    settingsAllowedTypes: 'Allowed talk types',
    settingsBlockedPhrases: 'Custom blocked phrases',
    settingsStorage: 'Storage Inspector',
    settingsRefresh: 'Refresh',
    settingsStorageLoading: 'Loading storage state...',
    storageMode: 'Mode',
    storagePersistence: 'Persistence',
    storageLocalNode: 'Local node',
    storageDirectChat: 'Direct chat',
    storageTransportFallback: 'Transport fallback',
    storageSupportBootstrap: 'Support bootstrap',
    storageAppState: 'App State',
    storageTechSupportRoot: 'TechSupport root identity',
    techSupportRootBadge: 'TechSupport (root)',
    storageCurrentIdentity: 'current identity',
    storageSupportChannel: 'Support channel',
    storageIncomingLanguages: 'Incoming languages',
    storageDefaultTalkLanguage: 'Default talk language',
    storageRoomVisits: 'Room visits / unique visitors',
    storageBrowserLocal: 'Browser local storage',
    storageNoLocalKeys: 'No localStorage keys',
    storageIndexedDb: 'IndexedDB',
    storageServerPaths: 'Server persisted paths',
    storageLocalNodeSupervisor: 'Local Node Supervisor',
    storageStatus: 'Status',
    storagePairing: 'Pairing',
    storageBridge: 'Bridge',
    storageSeaCustody: 'SEA Identity Custody',
    storageRelayScan: 'Relay scan',
    storagePublicKeys: 'Public keys',
    storageForbidden: 'Forbidden',
    storageRelayRule: 'Relays may store routing metadata, public keys, nonces, signatures, and ciphertext only.',
    storageConversationTransport: 'Conversation Transport',
    storageActive: 'Active',
    storageMessages: 'Messages',
    storageReceipts: 'Receipts',
    storageFallback: 'Fallback',
    storageProtocol: 'P2P Network Protocol',
    storageVersion: 'Version',
    storageSubstrate: 'Substrate',
    storageDiscoveryTtl: 'Discovery TTL',
    storageSignature: 'Signature',
    storageNeighborMemory: 'P2P Neighbor Memory',
    storageScope: 'Scope',
    storageGraph: 'Graph',
    storageClearNeighbors: 'Clear neighbors',
    storageDisableMemory: 'Disable memory',
    storageExportEncrypted: 'Export encrypted',
    storageBlockPeer: 'Block peer',
    storageBootstrap: 'Bootstrap',
    storageDataOwnership: 'Data Ownership',
    storageDeviceLocalDelete: 'Device local delete',
    storageServerHeldData: 'Server-held data',
    storageMigrationTarget: 'Migration target',
    storageLastLocalDelete: 'Last local delete',
    storageServerRequests: 'Server requests',
    storageMoveEligible: 'Move eligible',
    storageTransportDiagnostics: 'Transport diagnostics',
    storageDisclosureStorage: 'Storage',
    storageDisclosureBandwidth: 'Bandwidth',
    storageDisclosureBattery: 'Battery',
    storageDisclosureBackground: 'Background behavior',
    storageDisclosurePort: 'Local port',
    storageDisclosureStopDelete: 'Stop and delete',
    storageDeleteDeviceLocal: "Delete this device's local data",
    storageRequestServerData: 'Request/delete server-held data',
    storagePurposeProfile: 'Profile foundation fields and private Q/A mirrors controlled by the user.',
    storagePurposePublicProfile: 'Stage name, avatar, languages, interests, and visibility-filtered profile fields.',
    storagePurposeReputation: 'Public reputation counters used for credit, blocking, age vouching, and send limits.',
    storagePurposeChatrooms: 'Automatic and custom chatroom metadata plus current membership map.',
    storagePurposeTalks: 'Author-owned talk definitions needed for broadcast and response replay.',
    storagePurposeIncoming: 'Current star-mode delivery inbox and dedup clusters for incoming talks.',
    storagePurposeConversations: 'Star-mode matched chat records retained for compatibility until direct transport replaces them.',
    storagePurposeTemplates: 'Chatbot answer templates and exact memory records owned by the responder.',
    storagePurposeExactMemory: 'Exact chatbot memory index for deterministic answer reuse.',
    storagePurposeStats: 'Aggregated talk response statistics with privacy thresholds and no precise location.',
    storageUnknown: 'unknown',
    storageDurable: 'durable',
    storageEnabled: 'enabled',
    storageDisabled: 'disabled',
    storageStopped: 'stopped',
    storageStarting: 'starting',
    storageRunning: 'running',
    storageUnhealthy: 'unhealthy',
    storageStopping: 'stopping',
    storageWiped: 'wiped',
    storageUnconfigured: 'unconfigured',
    storageLocalOnly: 'local-only',
    storageAvailable: 'available',
    storageActiveValue: 'active',
    storageRequired: 'required',
    storageOptional: 'optional',
    storageClean: 'clean',
    storageNeedsReview: 'needs review',
    storageSupported: 'supported',
    storageLocal: 'local',
    storageOff: 'off',
    storageShared: 'shared',
    storagePrivate: 'private',
    storagePublished: 'published',
    storageClears: 'clears',
    storageNotRun: 'not run',
    storageNone: 'none',
    storageQueued: 'queued',
    storageReview: 'review',
    storageTelemetryFree: 'telemetry-free',
    storageLocalVisible: 'local-visible',
    storageStarFallback: 'star fallback',
    storageBlockedCount: '{count} blocked',
    settingsHiddenIncoming: 'Hidden received talks by active filter',
    broadcastPreviewTitle: 'Review broadcast audience',
    broadcastPreviewHelp: 'Recipients are checked against their privacy and intake settings before any talk is sent.',
    broadcastPreviewEligible: 'eligible',
    broadcastPreviewExcluded: 'excluded',
    broadcastPreviewCancel: 'Cancel',
    broadcastPreviewSend: 'Send Broadcast',
    broadcastPreviewUnavailable: 'Preview unavailable; eligibility will be checked when sent.',
    broadcastPreviewFinalCheck: 'final check on send',
    broadcastPreviewRecipients: 'Recipients: {names}',
    broadcastPreviewSkipped: 'Skipped: {details}',
    broadcastPreviewNone: 'None',
    broadcastPreviewSupportExcluded: 'TechSupport support channel excluded from ordinary broadcast ({count}).',
    broadcastPreviewSenderOmitted: 'not sent from your OUT list',
    reasonIntakeLanguage: 'Language not accepted',
    reasonIntakeTalkType: 'Talk type not accepted',
    reasonIntakeMinDistance: 'Below minimum distance',
    reasonIntakeMaxDistance: 'Beyond maximum distance',
    reasonIntakeSentAfter: 'Older than time filter',
    reasonIntakeGrammar: 'Grammar filter',
    reasonIntakeDirtyWords: 'Content moderation filter',
    reasonIntakeCustomTerms: 'Custom blocked phrase',
    reasonTalkExpired: 'Talk expired',
    reasonBroadcastDisabled: 'Broadcasting disabled',
    reasonAgeGate: 'Age verification required',
    reasonBlockedUser: 'Blocked by user',
    reasonBroadcastMaxDistance: 'Broadcast distance limit',
    reasonTagTargeting: 'Audience tag targeting',
    reasonCapacity: 'Sender delivery capacity',
    reasonRateLimit: 'Delivery rate limit',
    statusBarUser: '{count} user',
    statusBarUsers: '{count} users',
    statusBarMatch: '{count} match',
    statusBarMatches: '{count} matches',
    filterLocationPending: 'Location not yet synced — distance filter inactive',
  },
  zh: {
    graphMyAnswers: '我的回答',
    graphOurTalks: '我们交流的话题',
    graphPlaceHistory: '你在这里的交流记录',
    graphPlaceEmpty: '这里还没有交流记录。',
    graphUnknownPlace: '地点',
    navChatrooms: '聊天室',
    navContacts: '联系人',
    navTalks: '话题',
    navMe: '我的',
    navSettings: '设置',
    statusContacts: '通过话题交流认识的联系人',
    statusTalks: '收到的话题已按内容合并。',
    statusMe: '已回答的问题记录',
    statusSettings: '功能与过滤设置',
    newRoom: '新建房间',
    returnHome: '返回主页',
    broadcast: '广播',
    filters: '筛选',
    chatroomCurrent: '当前',
    chatroomViewMode: '聊天室视图',
    chatroomListView: '列表',
    chatroomMapView: '地图',
    chatroomMapAriaLabel: '地理聊天室地图',
    chatroomMapLoading: '正在加载地图…',
    chatroomMapLoadFailed: '无法加载地图。请检查网络连接或使用列表视图。',
    chatroomMapLocateSelf: '定位到我',
    chatroomMapSummary: '显示 {count} 个地点。',
    chatroomMapCustomRoomsNote: '{count} 个没有公开位置的社区地点仍可在列表视图中使用。',
    chatroomPlaceStartupUnavailable: 'IinPublic 无法打开你保存的地点，因此已改为打开“附近”。',
    chatroomSwitchFailed: 'IinPublic 无法切换房间。请重试。',
    chatroomTraveler: '旅行者',
    chatroomNearbyName: '附近',
    chatroomCurrentGroupHeading: '你当前的群组',
    matchCollectionTitle: '收集匹配',
    matchCollectionHelp: '把这次外出遇到的人和回复归在一起，之后找出最合适的匹配。',
    matchCollectionStart: '开始收集',
    matchCollectionActiveTitle: '正在收集匹配',
    matchCollectionActiveSummary: '{elapsed} · 已触达 {people} 人 · {replies} 个回复 · {pending} 个待回复 · {matches} 个匹配',
    matchCollectionFinishedTitle: '上次收集',
    matchCollectionFinishedSummary: '{elapsed} · 已触达 {people} 人 · {replies} 个回复 · {pending} 个待回复 · {matches} 个匹配',
    matchCollectionBroadcast: '广播到本次收集中',
    matchCollectionReview: '查看收集结果',
    matchCollectionReviewTitle: '收集结果',
    matchCollectionReviewSummary: '已触达 {people} 人 · {replies} 个回复 · {pending} 个待回复 · {matches} 个匹配 · {mismatches} 个不匹配 · {late} 个迟到回复',
    matchCollectionNoPeople: '本次收集尚未触达任何人。',
    matchCollectionPerson: '用户 {person}',
    matchCollectionPersonSummary: '{replies} 个回复 · {pending} 个待回复',
    matchCollectionOpenPerson: '打开回复和聊天',
    matchCollectionPin: '置顶',
    matchCollectionUnpin: '取消置顶',
    matchCollectionDismiss: '忽略',
    matchCollectionRestore: '恢复',
    matchCollectionPrivateNote: '私人备注',
    matchCollectionLate: '迟到',
    matchCollectionLocationSummary: '{areas} 个公开区域 · {unavailable} 次发送没有位置定位',
    matchCollectionEncounterDistance: '相遇距离：约 {distance}',
    matchCollectionImportanceLabel: '收集优先级',
    matchCollectionImportanceNormal: '普通',
    matchCollectionImportanceImportant: '重要',
    matchCollectionImportanceMustHave: '必需',
    matchCollectionRankReason: '原因：{reasons}',
    matchCollectionReasonPinned: '已置顶',
    matchCollectionReasonMustHave: '通过必需条件',
    matchCollectionReasonMatches: '{count} 个加权匹配',
    matchCollectionReasonBreadth: '匹配 {count} 个话题',
    matchCollectionReasonNearby: '在附近遇到',
    matchCollectionReasonRecent: '最近回复',
    matchCollectionMustHaveFailures: '{count} 个必需条件未满足',
    matchCollectionFilterAll: '所有人',
    matchCollectionFilterMatches: '已匹配',
    matchCollectionFilterPending: '需要跟进',
    matchCollectionPendingAction: '仍在等待回复——打开聊天进行跟进',
    matchCollectionStop: '停止收集',
    matchCollectionDefaultLabel: '附近外出',
    matchCollectionStarted: '已开始收集匹配。准备好后广播你的话题。',
    matchCollectionEnded: '已停止收集匹配。稍后收到的回复仍会归入本次外出。',
    settingsMatchCollection: '收集附近的匹配',
    settingsMatchCollectionHelp: '默认开启。自动把附近遇到的人和他们的话题回复归在一起。关闭后停止收集。',
    chatroomPlacesHeading: '地点',
    chatroomPlacesEmpty: '还没有公开地点。可使用地图探索或创建一个地点。',
    chatroomNearbyHomeDescription: '根据模糊处理后的常用位置加入',
    chatroomNearbyTravelDescription: '根据你在地图上选择的位置加入',
    chatroomContactsDescription: '陌生人发现已关闭',
    chatroomPlaceDescriptionFallback: '任何人都可加入的公开地点',
    chatroomCapacitySummary: '{count} 人 · 最多 {capacity} 人',
    chatroomNearbyPointTitle: '这个位置附近',
    chatroomNearbyPointAction: '以访客身份加入',
    quietEnded: '安静模式结束：你重新以正常区域显示。',
    quietHidden: '安静模式：你已从附近和地图中隐藏。联系人仍可联系你。',
    quietBlurred: '安静模式：你只以较大区域（约 50 公里）显示。',
    quietHiddenNoTravel: '安静模式正在隐藏你。关闭“立即安静”（或离开安静地点）后才能加入附近。',
    settingsDistanceUnit: '距离单位',
    settingsDistanceUnitKm: '公里 (km)',
    settingsDistanceUnitMi: '英里 (mi)',
    locationSectionTitle: '你的位置',
    locationSectionHelp: '每个人都会显示在某处：作为居民显示在模糊的 GPS 位置，或作为旅行者 ✈ 显示在你选择的地点。你的确切位置永远不会被分享。',
    locationSourceTitle: '你的显示位置',
    locationSourceResident: '居民：我的设备位置',
    locationSourceResidentHelp: '使用你的 GPS，并模糊到下面的区域大小。你会遇到身边的人。',
    locationSourceTraveler: '旅行者 ✈：我选择的地点',
    locationSourceTravelerHelp: '永远不使用你的 GPS。其他人会看到你以旅行者身份出现在你选择的地点。',
    locationSourceWebOnly: '此设备无法提供位置，因此你会以旅行者 ✈ 身份出现在你选择的地点。',
    locationUseMine: '使用我的位置',
    locationUseMineHelp: '此应用的位置权限已关闭，因此你以旅行者 ✈ 身份出现。允许位置权限即可显示在你所在的地方。',
    locationPermissionUnavailable: '无法获取位置。请在浏览器或设备设置中允许 IinPublic 使用位置；在此之前，你会以旅行者 ✈ 身份出现在你选择的地点。',
    locationAreaTitle: '他人看到的区域',
    locationAreaClose: '近距离 — 房间范围约 {distance}（他人看到 {shown}）',
    locationAreaNeighborhood: '社区 — 约 {distance}',
    locationAreaCitywide: '全城 — 约 {distance}',
    locationAreaRegional: '区域 — 约 {distance}',
    locationAreaHelp: '你的圆点是这个大小方格的中心；方格内的所有人都显示在同一点。这个方格也是你的“附近”：方格越大，越不容易看出你的位置，但“附近”的人也可能更多。常驻和旅行者 ✈ 使用相同的大小。',
    quietTitle: '安静地点',
    quietHelp: '在家、公司或其他地点以及设定的时间自动进入安静模式。安静地点只保存在此设备上。',
    quietNow: '立即安静',
    quietActionTitle: '安静时',
    quietActionBlur: '更加模糊 — 只以约 {distance} 显示（推荐）',
    quietActionHide: '隐藏我 — 离开附近和地图（联系人仍可联系我）',
    quietPlacesTitle: '地点',
    quietPlacesEmpty: '还没有安静地点。',
    quietPlaceAdd: '在地图上添加安静地点',
    quietPlaceName: '地点名称',
    quietPlaceRadius: '半径',
    quietPlaceRemove: '删除',
    quietPlaceDefaultName: '安静地点',
    quietSchedule: '每天',
    quietScheduleStart: '安静开始',
    quietScheduleEnd: '安静结束',
    quietLimits: '并非绝对保证：如果你每晚都从同一区域消失，这种规律可能暗示你的住处。“更加模糊”比“隐藏”泄露更少。',
    quietPickerTitle: '添加安静地点',
    quietPickerIntro: '点击你希望进入安静模式的地点，例如家或公司。',
    quietPickerConfirm: '添加安静地点',
    quietPickerDisclosure: '只保存在此设备上，永远不会被发布或同步。',
    talkAudienceTitle: '与谁交换话题',
    talkAudienceEveryone: '我房间里的所有人',
    talkAudienceEveryoneHelp: '你所在附近或地点里的居民和旅行者。',
    talkAudienceResidents: '仅限居民',
    talkAudienceResidentsHelp: '跳过旅行者 ✈（包括所有网站用户）。旅行者身份由用户自己声明，因此无法阻止伪造 GPS 的人。',
    talkAudienceContacts: '仅限联系人',
    talkAudienceContactsHelp: '不与陌生人交换话题。你仍会出现在房间和地图上。',
    roomListAround: '{place} 附近',
    roomListPeople: '{count} 人',
    roomListYourRoom: '你的房间',
    nearbyPeopleNearYou: '你附近的人',
    nearbyCountNearYou: '附近 {count} 人',
    nearbyCountOnline: '附近 {count} 人 · {online} 人在线',
    nearbyGroupFirst: '第 1 组 · 离你最近的人',
    nearbyGroupNext: '第 {group} 组 · 附近的下一批人',
    placeGroupFirst: '第 1 组 · 这个地点的人',
    placeGroupNext: '第 {group} 组 · 这个地点的下一批人',
    nearbyGroupExhausted: '这里的人你暂时都认识过了。',
    nearbyGroupSearching: '正在寻找新的人…',
    nearbyMeetNewPeople: '认识新的人',
    nearbyBackToFirstGroup: '回到第 1 组',
    nearbyMeetConfirmTitle: '认识新的人？',
    nearbyMeetConfirmBody: '把这 {count} 个人换成附近的下一批人。你正在发布的 Talk 会自动发给他们。已匹配的人会留在联系人里。',
    placeMeetConfirmBody: '把这 {count} 个人换成这个地点的下一批人。你正在发布的 Talk 会自动发给他们。已匹配的人会留在联系人里。',
    nearbySentProgress: '已发送 {sent} / {total}',
    roomListPlaceTag: '地点',
    roomListPlaceFallback: '地点',
    roomListNearbyFallback: '附近群组',
    roomListHere: '就在这里',
    roomListOnline: '{people} 人在线 · {rooms} 个房间',
    roomListLoading: '正在加载房间…',
    roomListSort: '排序',
    roomListSortNearest: '最近',
    roomListSortBusiest: '最热闹',
    roomListSortMostRoom: '人数最少',
    roomListNearHeading: '你附近的房间',
    roomListEmpty: '目前没有其他有人的房间。',
    roomListShowMore: '显示更多房间',
    mapUserSelf: '你',
    mapUserRoomOne: '附近的一位用户：可以交换话题',
    mapUserRoomMany: '附近的 {count} 位用户：可以交换话题',
    mapUserOtherOne: '附近范围外的一位用户：前往该处即可交换话题',
    mapUserOtherMany: '附近范围外的 {count} 位用户：前往该处即可交换话题',
    mapUserLegendSelf: '你',
    mapUserLegendRoom: '可以交换话题',
    mapUserLegendOther: '不在你的附近范围',
    mapMemberMessage: '发消息',
    mapMemberProfile: '资料',
    mapOpenMe: '打开“我”',
    mapRelationship: '关系',
    mapOpenTalks: '打开话题',
    mapTravelHere: '漫游至此',
    mapTalkCount: '{count} 个话题',
    mapTalkOne: '1 个话题',
    mapTalksWith: '与 {name}',
    mapTalksEmpty: '此设备上暂无与此人交流的话题。',
    listBroadcastOutgoing: '发送中 ↓',
    listBroadcastIncoming: '接收中 ↑',
    mapBroadcastOutgoing: '正在向附近的人广播',
    mapBroadcastIncoming: '正在接收附近的广播',
    mapMemberMatched: '已匹配',
    mapMemberMatchCount: '{count} 个匹配话题 · 打开联系人详情',
    chatroomLoadingMembers: '正在加载成员...',
    chatroomLoadingOnlineUsers: '正在加载在线用户...',
    chatroomRename: '重命名',
    chatroomDelete: '删除房间',
    chatroomMetrics: '👥 {members} · 🚪 {visits} · ◎ {unique}',
    chatroomMemberOne: '{count} 位成员',
    chatroomMembers: '{count} 位成员',
    chatroomVisitOne: '{count} 次访问',
    chatroomVisits: '{count} 次访问',
    chatroomUniqueOne: '{count} 位访客',
    chatroomUniqueVisitors: '{count} 位访客',
    chatroomNoOtherUsers: '这里还没有其他用户',
    chatroomFirstHere: '你是这个聊天室中的第一位用户！',
    chatroomMatched: '已匹配',
    chatroomOnlineNow: '在线',
    chatroomMatchedCount: '已匹配',
    chatroomMutualTag: '个共同标签',
    chatroomMutualTags: '个共同标签',
    chatroomOpenFirst: '从列表打开一个聊天室（点按房间），或等待系统为你分配房间。',
    chatroomNoTalksToBroadcast: '没有可广播的话题。请先创建话题或启用已复制的话题。',
    chatroomAlreadyBroadcast: '当前内容已全部广播到此房间。',
    chatroomCreateTitle: '新建聊天室',
    chatroomCreateHelp: '创建社区或商业房间，任何人都可以从列表加入。',
    chatroomType: '类型',
    chatroomTypeCommunity: '社区 / 自定义',
    chatroomTypeBusiness: '商业',
    chatroomBusinessHeadline: '商业简介（可选）',
    chatroomBusinessPlaceholder: '简短标语',
    chatroomDetails: '房间详情',
    chatroomDescription: '描述',
    chatroomBusinessHeadlineLabel: '商业简介',
    chatroomCapacity: '容量',
    chatroomOwner: '创建者',
    chatroomCreatedDate: '创建时间',
    chatroomActiveMembers: '在线成员',
    chatroomLifetimeVisits: '累计访问',
    chatroomUniqueVisitorsLabel: '独立访客',
    chatroomName: '名称',
    chatroomDescriptionOptional: '描述（可选）',
    chatroomCapacityOptional: '容量（可选）',
    chatroomCapacityPlaceholder: '默认 50',
    chatroomCancel: '取消',
    chatroomCreate: '创建',
    chatroomNameTooShort: '名称至少需要 2 个字符。',
    chatroomCreateFailed: '无法创建房间。',
    chatroomCreateFailedWithReason: '无法创建房间：{reason}',
    chatroomCreated: '{name} 已创建。',
    chatroomRenameTitle: '重命名房间',
    chatroomCurrentName: '当前：{name}',
    chatroomNewName: '新名称',
    chatroomSave: '保存',
    chatroomRenameFailed: '重命名失败。',
    chatroomRenameFailedWithReason: '重命名失败：{reason}',
    chatroomRenamed: '房间已重命名。',
    chatroomDeleteConfirm: '删除此房间？所有人的列表中都将不再显示它。',
    chatroomDeleteFailed: '删除失败。',
    chatroomDeleteFailedWithReason: '删除失败：{reason}',
    chatroomDeleted: '房间已删除。',
    talksBroadcastDisabled: '广播已关闭',
    talksBroadcastEnabled: '广播已开启',
    broadcastNoChatroom: '未选择聊天室。',
    broadcastInProgress: '正在广播…',
    broadcastCancelled: '已取消广播。',
    broadcastSentOneOne: '已在此聊天室向 {users} 位用户发送 {talks} 个话题。',
    broadcastSentOneMany: '已在此聊天室向 {users} 位用户发送 {talks} 个话题。',
    broadcastSentManyOne: '已在此聊天室向 {users} 位用户发送 {talks} 个话题。',
    broadcastSentManyMany: '已在此聊天室向 {users} 位用户发送 {talks} 个话题。',
    broadcastFailed: '广播话题失败：{reason}',
    travelEnabled: '旅行模式已启用。选择任意房间前往该处。',
    travelReturnedHomeRoom: '已返回主房间。',
    travelReturnedHome: '已返回家中。',
    travelHomeSet: '主房间已设为 {name}。',
    chatroomMapEnterTile: '进入 ›',
    chatroomCreateNeedsLocation: '房间属于你所在的地点。请开启定位后再创建。',
    chatroomCreateNeedsCredit: '要创建你唯一的房间，至少需要 {requiredFriends} 人将你标记为好友，且屏蔽你的人不能超过 {maximumBlocks} 人。你现有 {friends} 个好友标记和 {blocks} 个屏蔽。',
    chatroomTrademarkNotice: '只使用你有权使用的名称和描述，遵守商标及其他法律。创建房间不代表你拥有某个商家或品牌。',
    chatroomCreateNameTaken: '这里已有“{name}”，正在加入。',
    chatroomCreateCreatorLimit: '你已经有一个房间“{name}”。每人只能有一个。',
    chatroomCreateCellFull: '这一带已有 {count} 个房间，请加入其中一个。',
    roomListPlacesNearHeading: '你附近的地点',
    travelLocationHeld: '旅行模式已开启，位置已更新但未切换房间。',
    travelMovedLocation: '已根据位置移动到新的聊天室',
    locationUpdateFailed: '更新位置失败：{reason}',
    filterByName: '按名字筛选',
    repliesTitle: '我的话题回复',
    clear: '清除',
    pinItem: '置顶',
    unpinItem: '取消置顶',
    back: '返回',
    loading: '加载中...',
    unavailable: '不可用',
    all: '全部',
    allRelations: '全部关系',
    friends: '朋友',
    relatives: '亲属',
    coworkers: '同事',
    acquaintances: '熟人',
    partners: '伴侣',
    custom: '自定义',
    recent: '最近',
    talkCount: '话题数',
    matchedTalks: '匹配的话题',
    matchRate: '匹配率',
    relevanceScore: '相关性得分',
    name: '姓名',
    contactsBroadcastGroupBtn: '广播给分组…',
    contactsOpenDm: '打开私信',
    broadcastGroupTitle: '广播给联系人分组',
    broadcastGroupPickGroup: '分组',
    broadcastGroupPickTalk: '话题',
    broadcastGroupPreview: '{count} 人 — 在线的会立即收到，其余的会在下次上线时收到（超过等待时限后会被丢弃）',
    broadcastGroupEmpty: '该分组暂无联系人',
    broadcastGroupSent: '已发送给该分组',
    talksAll: '全部',
    talksLatestActivity: '最近活动',
    talksOldestCreation: '最早创建',
    talksLatestReply: '最近回复',
    talksMostMatches: '匹配最多',
    talksMostReplies: '回复最多',
    talksBestMatchRate: '最佳匹配率',
    talksWeightedPerformance: '加权表现',
    talksTitle: '标题',
    talksStatusSummary: '{incoming} 个收到 · {outgoing} 个发出',
    talksNoTalks: '一次回答，开启数百场对话。',
    talksNoTalksHelp: '用自然语言写一个话题，或回答别人发来的话题。',
    talksStats: '回复：{responses} · 匹配：{matches} · 不匹配：{mismatches} · 忽略：{ignores} · 匹配率：{rate}%',
    talksNoStats: '—',
    talksWeightedScore: '得分 {score} = 匹配 x100 + 匹配率 x25 + 回复（最多 20）- 忽略 x4 - 不匹配 x2',
    talksLatestReplyLabel: '最近回复：{date}',
    talksMatchedWith: '已匹配：{names}',
    talksAlsoExchangedWith: '也曾与其交流：{names}',
    talksCopied: '已复制',
    talksCreated: '已创建',
    talksResults: '结果',
    surveyDefaultTitle: '问卷',
    surveyConnectResults: '连接服务器后可加载问卷结果。',
    surveyAnalyticsTitle: '问卷分析仪表板',
    surveyLoading: '加载中...',
    surveyCreateFollowUp: '创建后续问卷',
    surveyClose: '关闭',
    surveyLoadFailed: '无法加载仪表板（{status}）。{detail}',
    surveyNetworkError: '加载问卷分析仪表板时发生网络错误。',
    surveyResponses: '回复数',
    surveyQuestions: '问题数',
    surveyRegions: '地区数',
    surveyLatestDayBucket: '最近日期分组',
    surveyAnonymizeCohorts: '隐藏小样本群体（少于 {count} 条回复）',
    surveyExportSummary: '导出汇总 CSV',
    surveyExportDay: '导出按日 CSV',
    surveyExportRegion: '导出地区 CSV',
    surveyNoQuestionBreakdown: '还没有逐题统计。有人回答后，回复会显示在这里。',
    surveyHiddenUntil: '为保护匿名性，此问题获得至少 {count} 条回复前将隐藏结果。',
    surveyAnswersRecordedOne: '已记录 {count} 条回答',
    surveyAnswersRecorded: '已记录 {count} 条回答',
    surveyHiddenRegion: '已隐藏地区',
    surveyUnknownRegion: '未知',
    surveyNoFollowUpGaps: '未发现需要立即跟进的缺口。',
    surveyFollowUpCandidates: '后续问卷候选问题：{questions}',
    surveyQuestionDistribution: '逐题分布',
    surveyResponsesByDay: '按日回复',
    surveyResponsesByRegion: '按地区回复',
    surveyBucket: '日期分组',
    surveyCount: '数量',
    surveyNoResponses: '还没有回复。',
    surveyNoRegionData: '还没有地区数据。',
    surveyFollowUpHandling: '后续处理',
    surveyFollowUpHelp: '使用“创建后续问卷”可基于当前问卷新建问卷，并将其标记为 {title} 的后续问卷。',
    surveyExported: '已导出 {filename}',
    surveyFollowUpTitle: '后续问卷：{title}',
    surveyFollowUpQuestion: '根据此问卷，我们接下来应该改进什么？',
    surveyFollowUpDetails: '后续详情',
    surveyNoFollowUpNeeded: '无需后续跟进',
    surveyLocalData: '从本地回复记录中计算。',
    surveySkipRate: '跳过率',
    surveyCompletionRateLabel: '完成率',
    surveyCrossQuestion: '跨题相关性',
    surveyCrossQuestionEmpty: '需要至少 2 道题各有 ≥ {count} 条回复才能显示相关性。',
    surveyFilterLabel: '筛选回复',
    surveyFilterAll: '全部时间',
    surveyFilterDays7: '最近 7 天',
    surveyFilterDays30: '最近 30 天',
    surveyFilterDays90: '最近 90 天',
    surveyTimeSeries: '回复趋势',
    surveyTimeSeriesWeek: '按周回复',
    surveyTimeSeriesMonth: '按月回复',
    surveyMatchIgnoreBreakdown: '结果分布',
    statsLocalDashboard: '我的话题统计',
    statsLocalEmpty: '您的话题还没有收到回复。',
    statsLocalNote: '统计数据从本设备上的回复记录中本地计算。',
    statsByTypeHeader: '按话题类型',
    statsTopTalksHeader: '热门话题（按回复数）',
    statsTimeTrendHeader: '回复趋势（所有话题）',
    statsChatroomHeader: '按聊天室 / 位置',
    statsPeerHeader: '对等方回复摘要',
    statsBroadcastTagsHeader: '广播标签',
    talksBroadcastOff: '广播关闭',
    talksBroadcastOn: '广播开启',
    talksRemove: '移除',
    talksDetails: '详情',
    talksExpiration: '有效期：{value}',
    talksLocation: '位置：{value}',
    talksAnswered: '已回答',
    talksNew: '新话题',
    talksTagChecked: '已勾选标签',
    talksTagUndetermined: '未勾选标签',
    talksTagQuickDecision: '勾选以接受此标签',
    talksTagDecisionActions: '标签选择',
    talksTagPass: '跳过',
    talksOutgoingSection: '发出',
    talksTapHint: '点按标签即喜欢 · 在发出中点按已喜欢的标签即可跳过 · 长按选中后可用 ✕ ♡ 📌',
    talksTapModePass: '跳过选中的标签（长按一行即可选中）',
    talksTapModeLike: '喜欢选中的标签（长按一行即可选中）',
    talksTapModePin: '置顶或取消置顶选中的行（长按一行即可选中）',
    talksTagLike: '喜欢',
    talksTagPassed: '已跳过标签',
    talksTagLiked: '已喜欢标签',
    talksIgnore: '忽略',
    talksIgnored: '话题已移至忽略列表',
    talksRestore: '恢复',
    talksRestored: '话题已恢复',
    talksResponseOne: '{count} 个回复',
    talksResponses: '{count} 个回复',
    talksIncomingFallback: '收到的话题',
    talksSenderOne: '{count} 位发送者',
    talksSenders: '{count} 位发送者',
    talksFrom: '来自：{names}',
    talksView: '查看',
    talksOutSection: '{count} · 创建或复制',
    talksInSection: '{count} · 按内容合并{filtered}',
    talksCountOne: '{count} 个话题',
    talksCount: '{count} 个话题',
    talksFilteredCount: ' · {count} 个已过滤',
    talksAllIncomingFiltered: '当前所有收到的话题均已被过滤（{count} 个）。',
    talksNoIncoming: '还没有收到的话题。',
    talksNoOutgoing: '还没有发出的话题。',
    talksJustNow: '刚刚',
    talksMinutesAgo: '{count} 分钟前',
    talksHoursAgo: '{count} 小时前',
    talksDaysAgo: '{count} 天前',
    talksForever: '永久',
    talksExpired: '已过期',
    talksExpiresIn: '{value}后过期',
    talksAnywhere: '不限位置',
    talksMiles: '{count} 英里',
    talksDataNotFound: '找不到话题数据',
    talksAlreadyCopied: '已在我的话题中',
    talksCopyToMyTalks: '复制到我的话题',
    talksRemoveCopy: '从我的话题中移除副本',
    talksCopiedToList: '已添加到我的话题',
    talksCouldNotLoad: '无法加载话题。',
    talksCouldNotOpen: '无法打开话题。',
    talksCouldNotLoadRetry: '暂时无法加载此话题。请检查网络后重试。',
    nearbyOfflineWifiOff: '没有网络。打开 Wi-Fi 即可发现附近的手机——点此打开设置。',
    nearbyOfflineLocationOff: '没有网络。打开位置信息即可发现附近的手机——点此打开设置。',
    nearbyOfflineBluetoothOff: '没有网络。打开蓝牙即可发现附近的手机——点此打开设置。',
    settingsNearby: '发现附近的人',
    appPermissionsTitle: '应用权限',
    appPermissionsSubtitle: '安装 IinPublic 时统一询问过一次。可随时在 Android 设置中更改。',
    appPermissionNotifications: '通知',
    appPermissionNotificationsHelp: '应用在后台时提醒新的 Talk、匹配和消息。',
    appPermissionLocation: '位置',
    appPermissionLocationHelp: '把你放进你所在地点的聊天室。',
    appPermissionNearby: '附近的设备',
    appPermissionNearbyHelp: 'Wi-Fi 直连和蓝牙：即使没有网络也能发现身边的人。',
    appPermissionCamera: '相机',
    appPermissionCameraHelp: '扫描二维码。第一次扫描时才询问。',
    appPermissionAllowed: '已允许',
    appPermissionNotAllowed: '未允许',
    appPermissionsOpenSystem: '在 Android 设置中更改',
    settingsNearbySubtitle: '选择 IinPublic 可以使用哪些网络和无线方式来发现你聊天室里的人——即使没有网络。',
    settingsNearbyExchange: '附近交换',
    settingsNearbyModeOff: '关闭',
    settingsNearbyModeWhileOpen: '仅打开时——进入后台即暂停',
    settingsNearbyModeAlways: '始终——后台交换 Talk',
    settingsNearbyModeHelp: '只适用于当前活动聊天室。切换聊天室始终需要手动操作。',
    settingsNearbyCellular: '蜂窝网络（移动数据）',
    settingsNearbyCellularHelp: '关闭后，IinPublic 不会使用蜂窝网络来发现聊天室里的人。其他网络照常使用：连接 Wi-Fi 时仍可访问 iinpublic.com，附近的手机也会通过 Wi-Fi、Wi-Fi 直连和蓝牙被发现。',
    settingsNearbyLan: '在同一 Wi-Fi 上发现 IinPublic 手机',
    settingsNearbyLanHelp: '当聊天室里有人和你在同一 Wi-Fi 上时，这是免费又快速的连接方式。聊天室里只有你一人时保持静默。',
    settingsProviderOn: '已开启',
    settingsProviderOff: '已关闭',
    settingsProviderUnsupported: '此手机不支持',
    settingsProviderPermissionDenied: '需要权限——请在 Android 设置中允许“附近的设备”',
    settingsProviderRadioOff: '已在 Android 中关闭——请在快捷设置中打开',
    settingsNearbyStatusQuiet: '没有网络，附近暂时没有人——约 {count} 分钟后再次查找。',
    settingsNearbyStatusBridging: '已联网——你的手机正通过 Wi-Fi 直连与附近 {count} 台没有网络的手机交换话题。',
    settingsNearbyStatusBridgingJoined: '已联网——正通过 Wi-Fi 直连与附近没有网络的手机交换话题。',
    encounterLocationTitle: '相遇位置',
    encounterLocationHelp: '作为旅行者 ✈，IinPublic 从不读取你的 GPS。请选择你想遇见别人的地方——任何地方都可以，甚至可以不是你所在的位置。只会分享它周围的大致区域，绝不分享具体位置。',
    encounterLocationUnset: '未设置——在选择之前，你只会和联系人交流。',
    encounterLocationRandomHelp: '你目前以 ✈ 旅行者身份出现在地图上的随机位置。请选择你自己的位置，让附近合适的人找到你。',
    encounterLocationSet: '设置于 {date} · 仅保存在此设备上',
    encounterLocationSetButton: '在地图上设置相遇位置',
    encounterLocationChangeButton: '更改相遇位置',
    encounterLocationClearButton: '清除相遇位置',
    encounterPickerTitle: '选择你的相遇位置',
    encounterPickerIntro: '在地图上点选你想遇见别人的地方。可以是任何地方——不必是你所在的位置。',
    encounterPickerLatitude: '纬度',
    encounterPickerLongitude: '经度',
    encounterPickerUseCurrent: '使用我当前的位置',
    encounterPickerLocating: '正在向浏览器请求你的位置…',
    encounterPickerCurrentHint: '已在你当前的位置放置标记——可以移动它，然后确认。',
    encounterPickerCurrentFailed: '浏览器无法提供位置，请直接点选地图。',
    encounterPickerMapFailed: '地图无法加载，你仍可以输入坐标。',
    encounterPickerDisclosure: '地图图块来自 OpenFreeMap（OpenStreetMap 数据）；图块服务器能看到你查看的区域。你选择的位置只保存在此设备上。',
    encounterPickerConfirm: '使用此位置',
    settingsNearbyWifiDirect: '通过 Wi-Fi 直连在手机之间直接连接',
    settingsNearbyWifiDirectHelp: '在你或附近同一聊天室的手机没有网络时使用。你的手机会不经路由器，直接连接附近运行 IinPublic 的手机，即使其中一方没有网络也能交换话题。关闭后，附近的手机无法通过 Wi-Fi 直连发现你。',
    settingsNearbyBluetooth: '使用蓝牙发现附近的手机',
    settingsNearbyBluetoothHelp: '蓝牙只用来告诉对方“这里有一台同一聊天室的 IinPublic 手机”，让手机更快互相发现。它只做短时扫描，附近没人时扫描更少。话题从不经由蓝牙传输。关闭后，手机仍可通过 Wi-Fi 互相发现，只是更慢。',
    settingsNearbyPrivacyTitle: '附近的人能看到什么、不能看到什么',
    settingsNearbyPrivacySameWifi: '在同一个 Wi-Fi 下，同一聊天室的 IinPublic 手机会直接互相发现，和通过网站时一样。',
    settingsNearbyPrivacyOnlyOffline: 'Wi-Fi 直连只在聊天室里有手机没有网络时建立：离线手机之间、以及与附近联网的手机之间互相连接，以便继续交换话题。每种无线方式都只会发现你聊天室里的人——绝不超过聊天室允许的人数。',
    settingsNearbyPrivacyEncrypted: '话题和消息始终端到端签名并加密。负责连接的手机只是转发，无法读取或修改。',
    settingsNearbyPrivacyVisible: '附近运行 IinPublic 的手机可以知道附近有 IinPublic 用户，并能看到你在聊天室里分享的话题——与在线时同一聊天室里的人相同。你的名字、资料和位置与在线时分享的完全一样，绝不会更多。',
    settingsNearbyPrivacyBluetooth: '蓝牙信号不包含名字，且每 15 分钟更换一次代码，无法被用来追踪你。',
    settingsNearbyScreenOff: '“始终”模式会通过 Android 常驻通知，让加密 Talk 邮箱和已批准的自动回答在后台继续运行。手机厂商的省电机制仍可能延迟或停止它；若要获得最可靠的送达，请允许 IinPublic 不受电池限制。“仅打开时”模式会在应用页面被冻结或关闭时明确暂停交换。',
    settingsNearbyStatusStandby: '已联网——附近模式待命中。',
    settingsNearbyStatusOff: 'Wi-Fi 直连已关闭。',
    settingsNearbyStatusSearching: '没有网络——正在寻找附近的 IinPublic 手机…',
    settingsNearbyStatusHosting: '没有网络——你的手机正在为附近 {count} 台手机提供 Wi-Fi 直连。',
    settingsNearbyStatusJoined: '没有网络——已通过 Wi-Fi 直连连接附近的手机。',
    settingsNearbyStatusLan: '此 Wi-Fi 上有 {count} 台 IinPublic 手机。',
    nearbyOfflinePermissionDenied: '没有网络。允许“附近设备”权限即可发现附近的手机——点此打开设置。',
    talksViewInMyAnswers: '在我的回答中查看',
    talksDetailNotice: '话题：{title}',
    talksRemovedFromList: '已从列表移除话题',
    talksCompletedOutcome: '话题完成结果：{outcome}',
    talksAutoCaptured: '已记录自动话题，以后可再次使用。',
    talksCreateSyncSlow: '话题已保存在本地。服务器同步较慢，请稍后在聊天室中使用广播。',
    talksCreatedSent: '话题已创建并发送到聊天室！',
    talksCreatedSavedOnly: '话题已保存到你的列表（未发送到房间）。需要他人接收时，请在聊天室中使用广播。',
    talksCreatedNeedsRoom: '话题已创建。请打开聊天室并加入房间，然后使用广播发送给他人。',
    talksCreateFailed: '创建话题失败：{reason}',
    talksUpdated: '话题已更新。',
    talksUpdateFailed: '更新话题失败：{reason}',
    talksNotFound: '找不到话题。',
    talksLoadFailed: '加载话题失败：{reason}',
    talksMatchNoticePrefix: '匹配！',
    talksMatchNotice: '匹配！{name} 在“{title}”中注意到了你',
    talkTypeTag: '标签',
    talkTypeFlow: '流程',
    talkTypeSurvey: '问卷',
    talkTypeRoute: '路线',
    contextualStatsSummary: '统计：{responses} 条回复 · {matches} 个匹配 · {rate}% 匹配率{room}',
    contextualStatsRoom: ' · 最佳房间 {room}',
    contextualStatsHidden: '已隐藏',
    contextualStatsEmpty: '统计：还没有数据',
    repliesSearchPlaceholder: '昵称或话题',
    repliesAllOutcomes: '全部结果',
    repliesMatches: '匹配',
    repliesMismatches: '不匹配',
    repliesIgnored: '已忽略',
    repliesAutomatic: '自动',
    repliesStrangers: '陌生人',
    repliesAllTypes: '全部类型',
    repliesAllLanguages: '全部语言',
    repliesNewestFirst: '最新优先',
    repliesOldestFirst: '最早优先',
    repliesStageName: '昵称',
    repliesTalkTitle: '话题标题',
    repliesRelationship: '关系',
    repliesMatchesPerTalk: '每个话题的匹配数',
    repliesPerTalk: '每个话题的回复数',
    repliesNoGrouping: '不分组',
    repliesGroupUser: '按用户分组',
    repliesGroupTalk: '按话题分组',
    repliesGroupRelation: '按关系分组',
    repliesGroupDay: '按日期分组',
    repliesUnavailable: '回复不可用',
    repliesNoMatch: '没有符合过滤条件的回复。',
    repliesAnswers: '回答',
    repliesShowMore: '显示',
    repliesScopedToTalk: '话题：{title}',
    repliesClearScope: '清除 — 显示我所有话题的回复',
    repliesViewContact: '查看联系人',
    talksViewResponses: '查看回复（{count}）',
    contactsPromise: '通过真正在意的事找到彼此。',
    contactsEmpty: '创建或回答话题，合拍的人会出现在这里。',
    contactsNoMatch: '没有符合过滤条件的联系人。',
    contactsOutcomeAll: '所有结果',
    contactsOutcomeMatched: '已匹配',
    contactsOutcomeUnmatched: '未匹配',
    contactsPresenceAll: '在线与离线',
    contactsPresenceOnline: '当前在线',
    contactsLoading: '正在加载联系人...',
    contactsUnavailable: '无法加载联系人。',
    contactsCountOne: '{count} 位通过话题交流的联系人',
    contactsCount: '{count} 位通过话题交流的联系人',
    contactsTalkCountOne: '{count} 个话题',
    contactsTalkCount: '{count} 个话题',
    contactsMatchCountOne: '{count} 个匹配',
    contactsMatchCount: '{count} 个匹配',
    contactsCommonTagCountOne: '{count} 个共同标签',
    contactsCommonTagCount: '{count} 个共同标签',
    contactsMatchRateDetail: '{matched}/{total} 个标签匹配',
    contactsRankingExplanation: '{matches} 个匹配 x100 + {rate} 匹配率 + {relationship} 关系 + {recency} 最近活跃',
    contactsBlocked: '已屏蔽',
    contactsSupportPinned: '内置',
    contactsSupportBuiltIn: '内置支持联系人',
    contactsSupportOnline: '在线',
    contactsSupportAway: '离线',
    presenceOnline: '在线',
    presenceAway: '离线',
    contactNoRelationship: '未设置关系',
    contactRelationshipCredit: '关系与信用',
    contactNickname: '昵称',
    contactCustomLabel: '自定义标签',
    contactCustomLabelHelp: '仅在关系为自定义时使用',
    contactMyRating: '我的评分',
    contactNoRating: '未评分',
    contactStar: '星',
    contactStars: '星',
    contactPublicCredit: '公开信用',
    contactProfileUnavailable: '资料不可用。',
    contactCreditUnavailable: '无法加载公开信用。',
    contactCreditSummary: '{reviews} 条评价 · {friends} 位好友 · {liked} 个赞 · {disliked} 个踩',
    contactCreditHidden: '该用户隐藏了信用信息。',
    contactNotes: '备注',
    contactBlockStatus: '屏蔽状态',
    contactBlockedBy: '该用户已屏蔽你，其资料和投递入口不可见。',
    contactBlockedByMe: '你已屏蔽该用户，双方将不再收到彼此的话题。',
    contactNoBlock: '当前没有屏蔽。',
    contactVouchAdult: '担保已满 18 岁',
    contactBlockUser: '屏蔽用户',
    contactUnblockUser: '取消屏蔽',
    contactAgeVoteSubmitted: '已提交年龄验证担保。',
    contactBlockedNotice: '已屏蔽该用户，话题投递现已停用。',
    contactUnblockedNotice: '已取消屏蔽该用户。',
    blockNotifyModalTitle: '通知你的联系人？',
    blockNotifyModalBody: '私下让你的联系人知道你屏蔽了此人——除了你自己，没有人（包括我们）会知道是谁举报的。',
    blockNotifySafetyResourceNote: '如果这涉及安全问题，NCMEC（report.cybertip.org）或当地警方比单纯屏蔽更能采取行动。',
    blockNotifyPickGroup: '通知对象',
    blockNotifyPreview: '将通知 {count} 人',
    blockNotifySkip: '跳过',
    blockNotifyConfirm: '通知',
    contactCircleBlockWarning: '你的 3 位或以上联系人已屏蔽此人',
    contactCircleBlockWarningTitle: '来自你自己联系人的信号——其他任何人都看不到',
    buildTrustTooltip: '仅表示对方的应用构建是否为官方签名版本——与对方本人、其可信度或是否完成年龄验证无关',
    buildTrustOfficialVerified: '官方版本',
    buildTrustOfficiallySignedUnavailable: '官方签名（设备验证不可用）',
    buildTrustCommunityBuild: '社区版本',
    contactSupportControls: '支持通知',
    contactSupportDescription: 'TechSupport 会一直作为内置支持频道可用。静音只会关闭本地通知，不会移除该频道。',
    contactSupportNotificationStatus: '通知状态',
    contactSupportNotificationsOn: '支持通知已开启。',
    contactSupportNotificationsMuted: '支持通知已在本地静音。',
    contactMuteSupport: '静音支持通知',
    contactUnmuteSupport: '取消静音支持通知',
    contactSupportMutedNotice: '已在此设备上将 TechSupport 通知静音。',
    contactSupportUnmutedNotice: '已在此设备上开启 TechSupport 通知。',
    contactMatchToChat: '请先通过话题与该用户匹配，再开始对话！',
    contactClose: '关闭',
    contactSave: '保存',
    contactDetailsUnavailable: '该用户已屏蔽你，无法查看详情。',
    contactNoTalks: '尚未交换话题。',
    contactTalkFallback: '话题',
    contactCouldNotLoad: '加载失败',
    contactCouldNotLoadTalks: '无法加载话题。',
    contactSharedLanguage: '{language}（共同语言）',
    contactNoSharedLanguage: '没有共同的个人资料语言，发送消息前可考虑翻译。',
    publicProfile: '公开资料',
    languagesLabel: '语言',
    interestsLabel: '兴趣',
    notListed: '未填写',
    noPublicProfile: '未列出公开资料内容。',
    stranger: '陌生人',
    sent: '发送',
    received: '收到',
    relationship: '关系',
    peerLoadingStats: '正在加载关系统计...',
    peerLoadingHistory: '正在加载话题历史...',
    peerTalkHistory: '话题历史',
    peerLinkedIdentityBadge: '🔗 关联身份',
    peerLinkedIdentityNote: '您已验证这是您自己关联的身份之一。联系人、屏蔽、声誉、对话和问答不会在关联身份之间共享。',
    peerDate: '日期',
    peerOutcome: '结果',
    peerAutoMode: '自动模式 - 自动发送所有新话题',
    peerSendMyTalks: '发送我的话题',
    peerSendDirectMessage: '发送私信',
    peerMessagePlaceholder: '输入消息...',
    peerSendMessage: '发送消息',
    peerSending: '正在发送...',
    peerSentStatus: '已发送',
    peerChannelStatus: '频道传输',
    transportStarGun: '兼容星型同步',
    transportServerRelay: '加密中继',
    transportDirectP2P: '直接 P2P',
    transportFallbackReason: '回退原因：{reason}',
    transportNoFallbackActive: '当前未启用传输回退。',
    transportNoFallbackReported: '尚未报告回退原因。',
    transportLastHealthyContact: '最近确认通信：{time}',
    transportNoHealthyContact: '尚未记录已送达的消息。',
    peerProfileBlocked: '该用户已屏蔽你，无法查看详情。',
    peerBlockedDetail: '被屏蔽的用户无法查看此详情页面。',
    peerStatsUnavailable: '无法加载统计信息。',
    peerTalksExchanged: '交换的话题',
    peerMatchedCount: '{count} 个匹配',
    peerNickname: '昵称',
    peerMutualMatches: '共同匹配',
    peerMutualTags: '共同标签',
    peerStageName: '昵称：{name}',
    peerTalkExchangedOne: '交换了 {count} 个话题',
    peerTalksExchangedCount: '交换了 {count} 个话题',
    peerConversations: '匹配的话题（{count}）',
    peerMessages: '消息',
    peerDirectMessages: '私信',
    peerTalkFallback: '话题',
    peerStartChatting: '开始聊天...',
    peerAutoReplied: '自动回复',
    peerOpenChat: '打开聊天',
    peerHistoryUnavailable: '无法加载历史记录。',
    peerNoHistory: '尚未交换话题。',
    peerMatch: '匹配',
    peerMismatch: '不匹配',
    peerPending: '待处理',
    peerAllTalksSent: '所有话题均已发送',
    peerSentTalkOne: '已发送 {count} 个话题',
    peerSentTalks: '已发送 {count} 个话题',
    talksChooseWhoToDm: '选择要私信的对象',
    dmInboxTitle: '私信',
    dmInboxEmpty: '没有未读消息',
    peerNothingNewToSend: '没有新的话题可发送',
    peerSendTalksTo: '向 {name} 发送话题',
    peerSelectTalks: '选择要发送的话题：',
    peerSendUnavailableTitle: '无法发送',
    peerOmitAlreadySent: '已发送给该联系人',
    peerNoEligibleTalks: '没有可发送的话题',
    peerSentWithOmitted: '已发送 {sent} 个；{omitted} 个不可用',
    peerSendSelected: '发送选中话题',
    conversationUser: '用户',
    conversationNoConversations: '还没有对话',
    conversationFindMatch: '通过话题与他人匹配后即可开始聊天！',
    conversationBotAnswered: '由聊天机器人回答',
    conversationUnknown: '未知',
    conversationMatchedPreview: '已匹配！开始对话吧...',
    conversationStart: '开始对话吧！',
    conversationMatchedStart: '你们已匹配！开始对话吧...',
    conversationMessagePlaceholder: '输入消息...',
    conversationSend: '发送',
    conversationTransport: '传输方式',
    captureConfirmTitle: '要把它变成话题问题吗？',
    captureConfirmHelp: '这看起来像一个带选项的问题。要把它发送为可点击的话题问题，而不是普通文本吗？',
    captureConfirmAccept: '是的，做成话题',
    captureConfirmDecline: '不用，按文本发送',
    captureChipAnswered: '已回答',
    captureTalkCreatedNotice: '已保存为新话题，可在"话题"标签页查看',
    captureTalkAppendedNotice: '已新增一个问题 — 旧版本已更新',
    supportAutoAnswerPrefix: '自动回答',
    supportNewQuestionAck: '谢谢你，{name}。这是一个新问题，我们的人工客服会在这里回复你。',
    supportInboxTitle: '支持收件箱',
    supportInboxEmpty: '暂无待处理问题。',
    supportInboxQuestionLabel: '问题（发布前请编辑 —— 这将公开）',
    supportInboxPrivacyWarning: '此问题文本将会公开 —— 发布前请移除任何个人信息。',
    supportInboxAnswerLabel: '回答',
    supportInboxAnswerPublish: '回答并发布',
    techSupportRecoveryBannerTitle: 'TechSupport 恢复锚点已生效',
    supportDelegatesTitle: '委托人',
    supportDelegatesHelp: '让另一个账号帮忙回答支持问题，且无需分享你的 TechSupport 密钥。',
    supportDelegatesUserIdLabel: '对方的用户 ID',
    supportDelegatesLabelLabel: '标签（例如"Alice 的手机"）',
    supportDelegatesTtlLabel: '有效期（天）',
    supportDelegatesIssue: '授权',
    supportDelegatesEmpty: '尚未授权任何委托人。',
    supportDelegatesRevoke: '撤销',
    supportDelegatesRenew: '续期',
    supportDelegatesStatusActive: '生效中',
    supportDelegatesStatusRevoked: '已撤销',
    supportDelegatesStatusExpired: '已过期',
    supportDelegatesExpiresLabel: '有效期至 {date}',
    supportDelegateActivityTitle: '委托人活动',
    supportDelegateActivityEmpty: '暂无委托人回答的问题。',
    supportDelegateOptInTitle: '协助回答 TechSupport 问题',
    supportDelegateOptInHelp: 'TechSupport 邀请你协助回答支持问题。你将用自己的账号作答——提问者永远看不到你的名字。',
    supportDelegateOptInToggleLabel: '作为 TechSupport 委托人',
    supportDelegatesInvite: '邀请委托人',
    supportDelegatesInviteUser: '远程邀请用户',
    supportDelegatesInviteUserHelp: '向特定的人发送邀请，无论对方身在何处。发送前请核对名称和指纹；对方在自己的设置中接受，其请求仍需你批准。',
    supportDelegatesLookUp: '查找',
    supportDelegatesSendInvite: '发送邀请',
    supportDelegatesUnknownUser: '未找到该 ID 对应的用户。',
    supportDelegatesInviteSent: '邀请已发送。对方接受后，其请求将显示在“待处理”中。',
    supportDelegateTargetedInviteTitle: 'TechSupport 邀请你成为支持委托人',
    supportDelegateTargetedInviteHelp: '接受后将发送一个已签名的请求供审核。到期时间',
    supportDelegateTargetedInviteAccept: '接受',
    supportDelegateTargetedInviteDecline: '拒绝',
    supportDelegateTargetedInviteToast: 'TechSupport 邀请你成为支持委托人——请查看设置。',
    supportDelegateInviteHelp: '为你想邀请的人生成一次性邀请码。他们在自己的设置中输入该码以发送请求——你仍需在每个请求成为正式授权前逐一审核批准。',
    supportDelegateInviteCodeHelp: '将此邀请码分享给你想邀请的人。有效期 5 分钟。',
    supportDelegateInviteExpired: '邀请码已过期',
    supportDelegatesPendingTitle: '待处理请求',
    supportDelegatesPendingEmpty: '暂无待处理请求。',
    supportDelegatesApprove: '批准',
    supportDelegatesRequestedLabel: '请求于 {date}',
    supportDelegateOptInEnterCode: '我有邀请码',
    supportDelegateInviteEntryTitle: '成为支持委托人',
    supportDelegateInviteEntryHelp: '如果 TechSupport 给了你邀请码，在此输入以申请委托人权限。',
    supportDelegateInviteEntrySubmit: '发送请求',
    supportDelegateInviteEntryPending: '请求已发送。TechSupport 将审核——获批后你会在此看到加入选项。',
    supportDelegateInviteErrorInvalid: '该邀请码无效。',
    supportDelegateInviteErrorExpired: '该邀请码已过期。',
    supportDelegateInviteErrorUnavailable: '无法发送请求，请重试。',
    supportDelegateGrantExpiringSoonSelf: '你的 TechSupport 委托权限将在 {days} 天后到期。',
    supportDelegateGrantExpiringSoonOther: '{label} 的委托权限将在 {days} 天后到期——是否续期？',
    locationSuggestedRoom: '推荐聊天室：{room}',
    locationSuggestedRoomJoin: '加入',
    supportChannelReady: '{name} 支持频道已就绪。',
    matchChatReady: '匹配成功！你和 {name} 现在可以聊天了。',
    conversationNewMessage: '来自 {name} 的新消息',
    conversationAnswerFailed: '无法处理回答：{reason}',
    conversationNotInChatroom: '当前不在聊天室中。',
    conversationMessageSent: '消息已发送！',
    conversationSendFailed: '无法发送消息：{reason}',
    mediaShareUploading: '正在将 {name} 上传到 IPFS…',
    mediaShareBlockedRecipient: '无法与已屏蔽的用户分享媒体',
    attachmentDownload: '下载',
    attachmentLoading: '加载中…（正在从发送方获取）',
    mediaGalleryTitle: '共享（{count}）',
    mediaGalleryEmpty: '此对话尚未共享任何照片或文件。',
    mediaLinksEmpty: '此对话尚未共享任何链接。',
    mediaTabMedia: '媒体',
    mediaTabFiles: '文件',
    mediaTabLinks: '链接',
    conversationLoadFailed: '无法加载对话：{reason}',
    newTalkNotification: '📥 来自 {name} 的新话题：{title}',
    talksAutoAnsweredNotification: '🤖 你的聊天机器人已自动回答 {name} 的话题：{title}',
    responseSubmittedFlow: '回答已提交！有匹配时会通知你。',
    responseSubmittedTag: '标签回答已提交！',
    responseSubmittedSurvey: '问卷回答已提交，谢谢！',
    meNoAnswers: '你收到并回答的话题会显示在这里。',
    meAnswersIntro: '你收到并回答的话题（按相同的问题组合分组）：',
    meSearchAnswers: '搜索回答',
    meAll: '全部',
    meAuto: '自动',
    meManualFilter: '手动',
    meConditional: '条件',
    meTalkTypeFilters: '话题类型',
    meTagStateFilters: '标签状态',
    meTag: '标签',
    meQuestion: '问题 {count}',
    meAnsweredCount: '已回答 {count} 次',
    meAnsweredCounts: '已回答 {count} 次',
    meChoiceCount: '选择次数 {count}',
    meChatbotGenerated: '聊天机器人生成',
    mePermanent: '永久',
    meManual: '手动',
    meAutoUsedCount: '自动使用 {count} 次',
    meAutoUsedCounts: '自动使用 {count} 次',
    meLatestAutoUse: '最近自动使用：{date}',
    meContextHash: '上下文哈希：',
    meContextPath: '上下文路径：',
    meChecked: '已勾选',
    meUnchecked: '未勾选',
    meIndeterminate: '未确定',
    meNoMatchingAnswers: '没有符合这些筛选条件的已记录选择。',
    meItem: '{count} 项',
    meItems: '{count} 项',
    meWithinMile: '{count} 英里以内',
    meWithinMiles: '{count} 英里以内',
    meAnywhere: '不限位置',
    meFromSender: '来自 {count} 位发送者',
    meFromSenders: '来自 {count} 位发送者',
    meMostRecently: '最近一次 {date}',
    meContextCount: '{count} 个上下文',
    meContextCounts: '{count} 个上下文',
    meContextIndicatorTitle: '{count} 个上下文 — 点击查看详情',
    meUniversalAnswer: '在任何场景下答案相同',
    meViewTalk: '查看话题',
    meViewContact: '查看联系人',
    meActionLike: '喜欢选中的标签（长按一行即可选中）',
    meActionPass: '跳过选中的标签（长按一行即可选中）',
    meActionTalk: '打开所选回答的话题（长按一行即可选中）',
    meOpenTalk: '话题',
    meFilterLiked: '喜欢',
    meFilterPassed: '跳过',
    mePeopleWhoExchanged: '与你交流过这一问题的人',
    focusShowAll: '显示全部',
    meTalksWithQuestion: '问过这一问题的话题',
    contactsFilterTopic: '标签或问题',
    placeMetHere: '在此认识 {count} 人',
    placeTalksHere: '在此交流 {count} 个话题',
    placeWhereExchanged: '在哪里交流过',
    peerMetIn: '相识于',
    graphBack: '返回上一步',
    listActionPin: '置顶或取消置顶选中的行（长按一行即可选中）',
    contactsActionRemove: '移除选中的演示机器人（长按一行即可选中）',
    meAnsweredVia: '通过{type}回答',
    preferences: '偏好设置',
    preferencesAnswersTitle: '我的回答',
    preferencesNoAnswers: '还没有回答过问题。回答后会显示在这里，你可以管理偏好。',
    preferencesSummary: '你已回答 {count} 个问题，可以修改回答并设置再次遇到同一问题时的处理方式。',
    preferencesQuestionFallback: '问题',
    preferencesLastAnswered: '最近回答：{date}',
    preferencesUnavailable: '不可用',
    preferencesYourAnswer: '你的回答：',
    preferencesOptionsUnavailable: '（暂无其他选项；再次回答此问题后即可编辑）',
    preferencesMode: '模式：',
    preferencesAutoHelp: '自动模式会在下次自动使用此回答',
    preferencesAutoBadge: '自动',
    preferencesManualBadge: '手动',
    preferencesModeHelp: '“自动”使用“设置”中的统一范围；“手动”则每次询问你。',
    preferencesManualMode: '每次都问我',
    preferencesTemporaryMode: '相同上下文和选项',
    preferencesWheneverMode: '每当出现此选项',
    preferencesPermanentMode: '永久自动回答',
    preferencesSuppressedMode: '跳过此问题',
    preferencesDelete: '删除',
    preferencesClearAll: '清除全部回答',
    preferencesClearConfirm: '确定要清除所有已保存的回答吗？',
    preferencesAnswerUpdated: '回答已更新',
    preferencesModeChangedAuto: '模式已切换为自动',
    preferencesModeChangedManual: '模式已切换为手动',
    preferencesModeChangedTemporary: '仅在上下文和选项相同时重复此选择',
    preferencesModeChangedWhenever: '每当出现此答案时，它现在是你的首选',
    preferencesModeChangedPermanent: '模式已切换为永久自动回答',
    preferencesModeChangedSuppressed: '之后将自动跳过此问题',
    preferencesAnswerDeleted: '回答已删除',
    preferencesAnswersCleared: '全部回答已清除',
    myTalksTitle: '我的话题',
    myTalksEmpty: '你还没有创建或回答任何话题。创建或回答后会显示在这里。',
    myTalksSummary: '历史记录中有 {count} 个话题。',
    myTalksCreated: '由我创建',
    myTalksCopied: '已复制',
    myTalksAnswered: '由我回答',
    myTalksLastInteraction: '最近互动：{date}',
    myTalksId: '话题 ID：',
    myTalksRemove: '从历史记录移除',
    myTalksClear: '清除全部历史记录',
    myTalksClearConfirm: '确定要清除所有话题历史记录吗？',
    myTalksRemoved: '话题已从历史记录移除',
    myTalksCleared: '全部话题历史记录已清除',
    copy: '复制',
    match: '匹配',
    mismatch: '不匹配',
    online: '在线',
    editStageName: '编辑昵称',
    editProfile: '编辑资料',
    stageDialogCurrent: '当前：{name}',
    stageDialogNewName: '新昵称',
    stageDialogPlaceholder: '输入新昵称',
    stageDialogLength: '3 至 50 个字符',
    stageDialogCancel: '取消',
    stageDialogSave: '保存',
    stageDialogUpdateFailed: '更新昵称失败，请重试。',
    stageDialogTooShort: '昵称至少需要 3 个字符。',
    stageNameUpdated: '昵称更新成功！',
    profileDialogDescription: '更新基础资料。问答可见范围决定其他人加载你的资料时能看到什么（联系人是你在关系中添加的人）。',
    profileDialogHeadshot: '头像',
    profileDialogInterestPlaceholder: '例如：网球、咖啡、徒步',
    profileDialogDefaultCategory: '输入兴趣的默认分类',
    profileDialogCategoryHelp: '已知词语（例如“徒步”“正在找工作”）会自动选择分类；其他内容使用默认分类。',
    profileDialogAttributes: '资料项目',
    profileDialogQuestion: '问题',
    profileDialogAnswer: '回答',
    profileDialogVisibilityTitle: '谁可以在你的公开资料中看到这一项',
    profileDialogRemove: '移除',
    profileDialogAddAttribute: '添加项目',
    profileDialogSave: '保存资料',
    profileDialogLanguageRequired: '请至少输入一种语言。',
    profileDialogUpdateFailed: '更新资料失败，请重试。',
    profileUpdated: '资料更新成功！',
    meVisibilityEveryone: '所有人',
    interestCategoryCommunity: '社区',
    interestCategoryDiscussion: '讨论',
    interestCategoryPersonals: '交友',
    interestCategoryJobs: '工作',
    interestCategoryGigs: '兼职',
    interestCategoryResumes: '简历',
    interestCategoryForSale: '出售',
    interestCategoryHousing: '住房',
    interestCategoryServices: '服务',
    interestCategoryOther: '其他',
    profile: '资料',
    broadcastTagTrends: '广播标签趋势',
    credit: '信用',
    showToOthers: '向其他人显示',
    meProfileVisibilityHelp: '每项问答的可见范围（见编辑资料）',
    meNoPublicProfile: '还没有公开资料项目。',
    meVisibilityContacts: '仅联系人',
    meVisibilityPrivate: '仅自己',
    meTechSupportRole: '角色',
    meTechSupportRoleValue: 'IinPublic 网络支持',
    meTrendConnect: '连接应用服务器后可加载广播标签趋势。',
    meTrendNoData: '还没有广播定向数据。带前置标签的群发会在这里生成数据。',
    meTrendTag: '标签',
    meTrendWindow: '时间窗口',
    meTrendDaily: '每日（UTC）',
    meTrendHelp: '广播前置标签（兴趣定向）的滚动 UTC 日统计。',
    meTrendUnavailable: '无法加载广播标签趋势。',
    meCreditHelp: '你的声誉由他人赋予，而不是自我宣称。这份只读信誉摘要来自其他用户的互动。',
    meReviews: '评价',
    meStarRating: '星级',
    meFriends: '好友',
    meBlocks: '收到的屏蔽',
    meRoomCreationCredit: '自定义房间资格',
    meRoomCreationUnlocked: '已解锁——你可以创建唯一的自定义房间。',
    meRoomCreationLocked: '未解锁——需要 {requiredFriends} 个好友标记，且屏蔽不超过 {maximumBlocks} 个。当前：{friends} 个好友标记，{blocks} 个屏蔽。',
    meLiked: '点赞',
    meDisliked: '点踩',
    meMatches: '匹配数',
    meAgeVerified: '年龄已验证',
    talkTemplatePickerTitle: '开始一个话题',
    talkTemplatePickerSubtitle: '挑选一个模板作为起点 — 每个字段都可以自由编辑 — 或者从空白开始创建。',
    talkTemplateScratch: '从空白开始',
    talkTemplateScratchDesc: '使用空白编辑器创建话题。',
    talkTemplateSharedInterest: '共同兴趣',
    talkTemplateSharedInterestDesc: '找到对同一件事感兴趣的人。',
    talkTemplateActivityMeetup: '活动 / 聚会',
    talkTemplateActivityMeetupDesc: '邀请大家参加活动，并确认合适的时间。',
    talkTemplateQuickPoll: '社区快速投票',
    talkTemplateQuickPollDesc: '提出一个实用问题，收集社区成员的选择。',
    talkTemplateBuySell: '买 / 卖',
    talkTemplateBuySellDesc: '双向市场交易 — 声明你要买入或卖出的内容。',
    talkTemplateTaxi: '打车',
    talkTemplateTaxiDesc: '将乘客与司机实时匹配。',
    talkTemplateJob: '求职 / 招聘',
    talkTemplateJobDesc: '将求职者与招聘方匹配。',
    talkTemplateDating: '交友',
    talkTemplateDatingDesc: '基于相互年龄范围的约会匹配。仅限成人内容（18+）。',
    talkTemplateRoommate: '找室友',
    talkTemplateRoommateDesc: '将需要室友的人与有空房间的人匹配。',
    talkTemplateLostFound: '失物招领',
    talkTemplateLostFoundDesc: '让丢失物品的人与捡到物品的人重新联系。',
    talkTemplatePetSitting: '宠物看护',
    talkTemplatePetSittingDesc: '将需要宠物看护的人与提供看护服务的人匹配。',
    talkTemplateTutor: '学习伙伴 / 辅导',
    talkTemplateTutorDesc: '将需要辅导的人与提供辅导的人匹配。',
    talksStarterTitle: '入门话题',
    talksAnsweredByChatbot: '由你的聊天机器人自动回答',
    talksStarterBody: '使用适合你的标签，丢弃其余内容。保留的内容随时可编辑。',
    talksStarterMore: '从模板构建',
    talksStarterScratch: '从空白构建',
    starterTalkUse: '使用',
    starterTalkDrop: '丢弃',
    starterTalkSimpleTag: '标签',
    starterTalkPairTag: '成对标签',
    starterTalkPairAccepts: '与此配对：{answer}',
    starterContactDemoBadge: '演示机器人',
    tagDirectoryTitle: '标签',
    starterCreatePromptTitle: '有更具体的爱好吗？',
    starterCreatePromptBody: '只有少数人共享的标签，最能帮你找到同好。创建你自己的标签吧，下面的标签向导会告诉你怎么做。',
    starterCreatePromptAction: '＋ 创建我的标签',
    tagDirectorySearch: '查找标签',
    tagDirectoryEmpty: '还没有标签。去话题页喜欢几个吧。',
    tagPagePeopleCount: '{count} 人喜欢',
    tagPageInMyTags: '在你的标签中',
    tagPageNotInMyTags: '不在你的标签中',
    tagPageNobody: '和你交换过话题的人中还没有人喜欢它。',
    tagsInCommon: '{count} 个共同标签',
    peerTagsTitle: '标签',
    contactsSortSharedTags: '共同标签最多',
    settingsContactsCap: '只交换过话题的人最多保留',
    settingsContactsCapHelp: '超出后，共同标签最少、最久以前遇到的人会离开联系人。你发过消息、标记、加标签、置顶或屏蔽的人始终保留。',
    starterContactRemove: '移除',
    editorBrowseTemplates: '🎨 从模板开始',
    editorCreateTitle: '创建话题',
    editorEditTitle: '编辑话题',
    editorPromise: '写对话，不写代码。',
    editorDescription: '创建分支对话流程，每个回答都可以进入不同问题。',
    editorTagDescription: '标签：一个关键词。其他人直接选择“喜欢”或“跳过”。',
    editorTalkTitle: '话题标题',
    editorLanguage: '语言',
    editorType: '类型',
    editorTagTypeName: '标签',
    editorFlowTypeName: '流程',
    editorSurveyTypeName: '问卷',
    editorRouteTypeName: '路线',
    editorMoreOptions: '更多选项',
    editorTagPairLabel: '这是什么？（可选）',
    editorTagPairPlaceholder: '例如：买、卖、招聘、求职',
    editorTagPairOppositeLabel: '将展示给标记为以下内容的人：',
    editorTagPairNoOpposite: '匹配所有同样标记为"{tag}"的人。',
    editorPreviewToggle: '👁 预览：接收者会看到什么',
    editorPreviewEmpty: '填写一个问题即可查看预览。',
    editorPreviewMatchResult: '✅ 这将会是一次匹配。',
    editorPreviewIgnoreResult: '❌ 这将会被过滤（忽略）。',
    editorPreviewSurveyComplete: '问卷完成 — 谢谢！',
    editorPreviewRestart: '↺ 重新开始预览',
    editorRoleLabel: '此交易中的角色（可选）',
    editorRoleNone: '无角色',
    editorRoleOffer: '提供方（我有或提供某物）',
    editorRoleRequest: '需求方（我想要或需要某物）',
    editorRoleHelp: '角色相同的两个话题永远不会匹配（例如两个买家）——只有相反的角色才能匹配。',
    editorQuestions: '问题与分支',
    editorAddQuestion: '+ 添加问题',
    editorExpiration: '有效期',
    editorLocation: '位置',
    editorSendChatroom: '发送到聊天室',
    editorAdult: '成人内容（18+）- 仅发送给已验证年龄的用户',
    editorAttachment: '附加媒体（匹配成功后自动分享链接）',
    editorExistingAttachment: '匹配后分享的照片',
    editorCancel: '取消',
    editorCreate: '创建',
    editorSave: '保存更改',
    editorTitlePlaceholder: '例如：咖啡聚会、快速问卷',
    editorTagPlaceholder: '例如：咖啡、网球、工作',
    editorTagKeyword: '标签关键词',
    editorTagLike: '我喜欢这个标签',
    editorTagOption: '标签（单个关键词；直接选择“喜欢”或“跳过”）',
    editorFlowOption: '流程 - 通过连续问题寻找合适的人',
    editorSurveyOption: '问卷 - 通过独立问题汇总统计',
    editorRouteOption: '路线 - 分支问题图（树状编辑器）',
    editorRouteTitle: '路线（分支图编辑器）',
    editorRouteHelp: '创建分支树。每个答案可以进入后续问题。同一路径中问题不能重复；不同分支可使用同一问题并拥有独立上下文。',
    editorRouteKindMatch: '匹配',
    editorRouteKindIgnore: '忽略',
    editorRouteKindTerminal: '终点',
    editorRouteKindLink: '后续问题',
    editorRouteQuestionPrefix: '问：',
    editorRouteQuestionPlaceholder: '问题（以 ? 结尾）',
    editorRouteAnswerPlaceholder: '答案内容（例如：是。）',
    editorRouteAddChild: '+ 子问题',
    editorRouteAddParallel: '+ 并行问题',
    editorRouteParallelThresholdLabel: '至少匹配 {count} 项中的 ___ 项（留空 = 全部）：',
    editorRouteParallelThresholdAll: '全部',
    editorRouteRemoveQuestion: '移除问题',
    editorRouteDefaultMatch: '匹配。',
    editorRouteNewAnswer: '新答案。',
    editorRouteRequired: '路线至少需要一个问题',
    editorTagRequired: '必须输入标签关键词',
    editorFinancialDataBlocked: '保存前请移除银行卡号或其他财务/银行信息 — IinPublic 仅用于交流，不可用于任何金钱交易。',
    editorCannotSave: '无法保存，请修正：',
    editorAutoFixed: '已自动修正：',
    editorForever: '永久',
    editorOneYear: '一年',
    editorOneMonth: '一个月',
    editorOneWeek: '一周',
    editorOneDay: '一天',
    editorAnywhere: '不限位置',
    editorMiles: '{count} 英里',
    editorRouteDescription: '路线：分支问题图。每个答案可以进入后续问题；同一问题可出现在不同分支并拥有独立上下文。',
    editorSurveyQuestions: '问题（相互独立）',
    editorSurveyHint: '问卷：问题彼此独立，不进行分支；每个答案用于汇总统计。',
    editorSurveyDescription: '问卷：独立的问题与答案组合，每个答案都会统计次数。',
    editorFlowQuestions: '问题（流程）',
    editorFlowHint: '流程：每个问题必须唯一；第一个答案决定匹配或后续问题，其余答案视为忽略。',
    editorFlowDescription: '流程：连续且不重复的问题；第一个答案决定走向，其余答案视为忽略。',
    editorFlowConstraint: '流程话题中仅第一个答案决定走向；保存时其余答案会标准化为忽略。',
    editorQuestionNumber: '问题 {count}',
    editorAnswerPlaceholder: '答案 {count}',
    editorMyAnswer: '我的答案',
    editorIgnore: '忽略',
    editorIgnoreFilter: '忽略（过滤掉）',
    editorNoticed: '注意到（匹配）',
    editorGoToQuestion: '前往问题 {count}',
    editorQuestionPlaceholder: '输入问题（例如：你喜欢咖啡吗？）',
    editorAddAnswer: '+ 添加答案',
    editorAdvancedToggle: '高级选项',
    editorAnswerSelectionModeLabel: '接收者可以选择：',
    editorAnswerSelectionModeSingle: '单选',
    editorAnswerSelectionModeMultiple: '多选（任意勾选）',
    editorSimpleTagLabel: '简单标签（答案必须与问题本身一致 — 除"忽略"外，需要恰好 1 个真实答案）',
    editorReciprocalTagLabel: '配对标签 — 在此定义买/卖上下文，供后续问题使用（除"忽略"外，需要恰好 1 个真实答案）',
    editorBuiltInKindLabel: '比较方式：',
    editorBuiltInKindNone: '普通答案选项',
    editorBuiltInKindQuantity: '数量（数字比较）',
    editorBuiltInKindPriceRange: '价格区间（重叠比较）',
    editorBuiltInKindTimeFrame: '时间范围（日期重叠比较）',
    editorBuiltInKindLocation: '位置（范围匹配）',
    editorBuiltInKindAgeRange: '年龄范围（相互匹配的约会条件）',
    editorBuiltInQuantityLabel: '数量：',
    editorBuiltInPriceMinLabel: '最低价格：',
    editorBuiltInPriceMaxLabel: '最高价格：',
    editorBuiltInTimeStartLabel: '起始日期：',
    editorBuiltInTimeEndLabel: '结束日期：',
    editorBuiltInLocationNote: '使用本话题自身的位置与范围（在下方设置）。',
    editorBuiltInAgeLabel: '我的年龄：',
    editorBuiltInAgeMinLabel: '可接受年龄，最低：',
    editorBuiltInAgeMaxLabel: '可接受年龄，最高：',
    editorBuiltInQuantityRequired: '请为该内置比较问题输入数量。',
    editorBuiltInPriceRangeRequired: '请为该内置比较问题输入有效的最低/最高价格区间。',
    editorBuiltInTimeFrameRequired: '请为该内置比较问题输入有效的日期范围。',
    editorBuiltInAgeRangeRequired: '请输入你的年龄以及有效的可接受伴侣年龄范围（最低/最高）。',
    editorRemove: '移除',
    responseTagHelp: '如果这个标签符合你，请勾选',
    responseInterested: '匹配（我感兴趣）',
    responseSubmit: '提交',
    responseSelectAtLeastOne: '请至少选择一项。',
    responseQuestion: '问题',
    responseAnswer: '回答',
    responseOf: '共',
    responsePrevious: '上一个问题',
    responseProgress: '回答进度',
    responseEstimateMinute: '约 {count} 分钟',
    responseEstimateMinutes: '约 {count} 分钟',
    responseRouteLeadsTo: '这会进入：{question}',
    responseRouteLeadsToMatch: '这会进入匹配结果',
    responseRouteLeadsToIgnore: '这会结束此路径',
    responseRouteLeadsToEnd: '这会结束此路径',
    responseRouteChange: '更改',
    responseRouteContinue: '继续',
    responseClose: '关闭回答',
    responseRememberAs: '记住为',
    responseAuto: '自动',
    responseWhenever: '每当出现此选项',
    responseManual: '手动',
    responsePermanent: '永久',
    responseIgnore: '忽略',
    responseInvalidTag: '标签无效',
    responseMissingQuestions: '无法加载话题（缺少问题）。',
    responseMatch: '匹配成功！你们彼此都注意到了对方。',
    responseMatchAuto: '匹配成功！你们彼此都注意到了对方。（自动）',
    responseTagIgnored: '已忽略标签 - 未匹配',
    responseTalkIgnored: '已忽略话题 - 未匹配',
    responseTalkIgnoredAuto: '已忽略话题 - 未匹配（自动）',
    refreshLocation: '刷新位置',
    settingsStageName: '昵称',
    settingsHeadshot: '头像',
    settingsInitial: '首字母',
    settingsChoosePhoto: '选择照片',
    settingsTakePhoto: '拍照',
    settingsRemove: '移除',
    settingsPhotoHelp: '任何照片都可以，会自动缩小。头像将公开显示。',
    settingsPhotoPreviewTitle: '预览头像',
    settingsPhotoPreviewHelp: '确认后，这张照片将在您的公开资料中显示。',
    settingsPhotoPreviewCancel: '取消',
    settingsPhotoPreviewSave: '使用照片',
    settingsCameraCaptureTitle: '拍摄头像',
    settingsCameraCaptureHelp: '将自己置于取景框内，然后拍摄预览。',
    settingsCameraCapture: '拍摄',
    settingsCameraUnavailable: '此设备无法使用相机拍摄。请改为选择照片。',
    settingsCameraDenied: '相机访问被拒绝。请选择照片，或允许相机访问。',
    settingsDistanceInvalid: '最小距离不能大于最大距离。',
    settingsStageNameTooShort: '昵称至少需要 3 个字符。',
    settingsStageNameReserved: '该昵称为保留名称，请选择其他昵称。',
    settingsStageNameUpdateFailed: '无法更新昵称。',
    settingsPhotoInvalidType: '该文件不是本设备可读取的图片。',
    settingsPhotoTooLarge: '照片文件过大，无法处理。',
    settingsPhotoReadFailed: '无法读取照片。',
    settingsAppearance: '外观',
    settingsAppearanceHelp: '为整个应用选择配色方案。',
    schemeGoldenHour: '黄金时刻',
    schemeTropicalForest: '热带雨林',
    schemeSnowMountain: '雪山滑雪',
    schemeBeachSunset: '海滩日落',
    appDownloadBannerText: '您正在使用网页版。',
    appDownloadBannerGetApp: '获取 {platform} 应用',
    appDownloadBannerSeeOptions: '查看下载选项',
    appDownloadBannerDismiss: '关闭',
    appUpdateReminderText: 'IinPublic {version} 已发布。',
    appUpdateReminderGetUpdate: '更新',
    p2pVersionMismatchOlderReminder: '一位联系人使用的是 IinPublic {remoteVersion}，比你的 {localVersion} 更新 — 请更新应用以兼容新功能。',
    p2pVersionMismatchNewerReminder: '你使用的是 IinPublic {localVersion}，比这位联系人的 {remoteVersion} 更新 — 部分新功能对方可能还无法使用。',
    settingsDownloadApp: '下载应用',
    settingsDownloadAppSubtitle: '支持 Mac、Windows 和 Android 的原生应用。',
    settingsDownloadAppComingSoon: '即将推出',
    settingsLanguages: '语言',
    settingsUiLanguage: '界面语言',
    settingsProfileLanguage: '个人资料语言',
    settingsDefaultTalkLanguage: '新话题默认语言',
    settingsIncomingLanguage: '接收话题语言过滤',
    settingsActive: '已启用',
    settingsTalkBehavior: '话题行为',
    settingsCopyTalk: '保留我接受的标签副本',
    settingsChatbot: '启用聊天机器人',
    settingsChatbotHelp: '教它一次，一个答案就能用于数百场对话。你的聊天机器人只复述你，而不编造你。',
    settingsAutoAnswerScope: '自动回答范围',
    settingsAutoAnswerScopeHelp: '此设置适用于所有标记为“自动”的回答。',
    settingsAutoAnswerSameContext: '相同上下文',
    settingsAutoAnswerWhenever: '每当出现此选项',
    settingsLocationAutoMatch: '允许聊天机器人使用我的大致（模糊）位置自动匹配',
    settingsLocationAutoMatchNote: '自动匹配只会使用你的大致位置。除非你本人主动选择分享，否则绝不会自动发送你的精确位置。',
    settingsKeepOldTalkOnEdit: '编辑时保留旧版本话题（高级选项 — 默认会移除旧版本）',
    settingsDistanceHome: '距离与主页',
    settingsMinDistance: '最小距离（英里）',
    settingsMaxDistance: '最大距离（英里）',
    settingsSentAfter: '只接收此时间之后发送的话题',
    settingsHomeRoom: '主页房间',
    settingsLocation: '位置',
    settingsUnknown: '未知',
    settingsContentFilters: '内容过滤',
    settingsContentFiltersHelp: '自由表达，也为自己的话负责。由你选择什么内容可以到达你。',
    settingsContactsOnlyTalks: '仅与联系人交换话题',
    settingsContactsOnlyTalksHelp: '不向陌生人发送你的话题，并忽略他们的话题和话题回复。你仍然可以在聊天室和附近列表中看到其他人。',
    settingsMessageFiltersHeading: '消息过滤',
    settingsFilteredIncomingHeading: '已过滤的接收内容',
    settingsGrammar: '语法过滤',
    settingsGrammarHelp: '检查标题和问题提示的句子长度、标点及明显重复，确保可读性。',
    settingsGrammarStrictness: '同时作用于话题和消息；严格度 {threshold}（固定）。',
    settingsDirtyWords: '敏感词过滤',
    settingsDirtyWordsHelp: '使用英文和中文审核词表检查标题、问题与答案选项。',
    settingsDirtyWordsListLabel: '屏蔽词',
    settingsDirtyWordsListHelp: '同时作用于话题和你的私信（双向）。内置垃圾词始终生效。',
    settingsDirtyWordAddPlaceholder: '添加一个词',
    settingsDirtyWordAdd: '添加',
    settingsDirtyWordReset: '恢复默认',
    settingsDirtyWordTooShort: '词语至少需要 2 个字符。',
    settingsDirtyWordDuplicate: '该词已在列表中。',
    settingsDirtyWordLimit: '最多只能有 50 个词。',
    messageBlockedDirtyWord: '未发送：包含屏蔽词',
    messageBlockedGrammar: '未发送：未通过语法检查',
    messageBlockedFinancialData: '未发送：内容疑似包含银行卡号或其他财务信息。IinPublic 仅用于交流。',
    messageHiddenDirtyWord: '一条消息已被你的敏感词过滤器隐藏',
    messageHiddenGrammar: '一条消息已被你的语法过滤器隐藏',
    safetyToastPreSend: 'IinPublic 仅用于交流，请勿分享银行卡号或通过本应用转账。',
    safetyToastPostMatch: '你们已匹配成功。请勿通过本应用转账——如需完成交易，请当面付款；如是初次见面，请选择公共场所。',
    messageHiddenPlaceholder: '条消息被你的过滤器隐藏',
    settingsLinkedDevices: '已关联设备',
    settingsLinkedDevicesHelp: '管理使用独立密钥的身份之间的直接关联。',
    settingsIdentityDevices: '身份与设备',
    settingsIdentityDevicesHelp: '查看此设备的身份、本地保护、名称和直接身份关联。',
    settingsOwnershipPromise: '你的身份。你的答案。你的数据。',
    settingsGroupPersonalization: '个性化',
    settingsGroupTalksDiscovery: '话题与发现',
    settingsGroupIdentityTrust: '身份与信任',
    settingsGroupAppData: '应用与数据',
    settingsGroupSupport: '支持',
    settingsManage: '管理',
    linkedDeviceDefaultName: '已关联设备',
    identityDevicesTitle: '身份与设备',
    identityCardTitle: '你的身份',
    identityFingerprintLabel: '身份指纹',
    identityStatusAvailable: '可在此设备上使用',
    identityStatusLocked: '已锁定',
    identityStatusNeedsAttention: '需要处理',
    identityStoredLocally: '此身份存储在这台设备上。IinPublic 不会在服务器上保留账户副本。',
    copyFullIdentityId: '复制完整身份 ID',
    identityIdCopied: '身份 ID 已复制。',
    identityIdCopyFailed: '无法复制身份 ID。',
    identityProtectionTitle: '身份保护',
    identityPasswordNotSet: '身份密码：未设置',
    identityPasswordSet: '身份密码：已设置',
    identityOpensAutomatically: 'IinPublic 会在此设备上自动打开。',
    identityPasswordPlanned: '可选密码保护将在密钥保管设计通过安全审查后提供。',
    identityUnlockedThisSession: '本次会话已解锁。重新加载或手动锁定后需要再次输入密码。',
    setIdentityPassword: '设置身份密码',
    changeIdentityPassword: '更改身份密码',
    removeIdentityPassword: '移除身份密码',
    lockIdentityNow: '立即锁定',
    identityUnlockTitle: '解锁你的身份',
    identityUnlockHelp: '请输入此设备的本地身份密码。',
    identityPasswordLabel: '身份密码',
    showPassword: '显示密码',
    unlockIdentity: '解锁身份',
    unlockingIdentity: '正在解锁…',
    identityUnlockFailed: '无法解锁。请检查密码后重试。',
    forgotIdentityPassword: '为什么无法重置此密码？',
    identityPasswordNoReset: 'IinPublic 无法重置此密码。如果忘记密码，此设备上唯一的选择是清除本地数据并使用不同身份重新开始。',
    eraseAndStartOver: '清除并重新开始',
    identityPasswordPermanentWarning: 'IinPublic 不会将你的密码或身份存储在恢复服务器上。任何人（包括 IinPublic）都无法恢复或重置此密码。如果忘记密码，此设备上的身份和本地加密数据可能永久无法访问。已关联的设备无法解锁此设备。你可以抹除此设备并重新开始，但这无法恢复原身份。',
    newIdentityPassword: '新身份密码',
    confirmIdentityPassword: '确认身份密码',
    currentIdentityPassword: '当前身份密码',
    identityPasswordStrengthGuidance: '请至少使用 15 个字符；允许使用空格和任何语言。',
    identityPasswordWarningAck: '我明白此密码无法恢复或重置',
    identityPasswordAcknowledgeRequired: '请先确认无密码重置警告。',
    identityPasswordMismatch: '两次输入的密码不一致。',
    identityPasswordTooShort: '请至少使用 15 个字符。',
    identityPasswordSetFailed: '无法设置身份密码。现有身份未被更改。',
    identityPasswordChangeFailed: '无法更改密码。请检查当前密码后重试。',
    removeIdentityPasswordWarning: '移除密码后，此身份将在本设备上自动打开。浏览器存储将包含解锁身份所需的全部信息。任何能够复制或访问此浏览器本地数据的人都可能使用你的身份。此操作不会删除你的身份或数据。',
    removeIdentityPasswordAck: '我明白移除密码会降低此设备上的身份保护。',
    identityPasswordRemoveFailed: '无法移除密码。请检查当前密码后重试。',
    setPassword: '设置密码',
    changePassword: '更改密码',
    removePassword: '移除密码',
    thisDeviceTitle: '此设备',
    thisDeviceBadge: '此设备',
    identityCreatedLabel: '身份创建日期',
    deviceProtectionAutomatic: '保护：自动',
    deviceProtectionPassword: '保护：身份密码',
    renameDevice: '重命名设备',
    deviceNameLabel: '设备名称',
    deviceNameRequired: '请输入设备名称。',
    defaultAndroidDeviceName: '此 Android 设备',
    defaultIosDeviceName: '此 iOS 设备',
    defaultDesktopDeviceName: '此桌面应用',
    defaultBrowserDeviceName: '此浏览器',
    linkedDevicesTitle: '已关联设备',
    linkedDevicesEmpty: '没有已关联设备',
    linkedDevicesEmptyHelp: '关联你控制的另一台设备。私钥会保留在创建它的设备上。',
    linkedDevicesNoTransfer: '直接关联不会授权数据传输、同步、恢复，也不会合并内容作者身份。',
    linkedDeviceStateWaiting: '等待批准',
    linkedDeviceStateLinked: '已关联',
    linkedDeviceStateRevocationPending: '撤销待处理',
    linkedDeviceStateRemoved: '已移除',
    linkedDeviceStateInvalid: '无效',
    linkedDeviceStateConflicted: '存在冲突 — 需要检查',
    deviceSyncEnable: '启用同步',
    deviceSyncPending: '同步待处理…',
    deviceSyncActive: '同步中',
    deviceSyncConflictsTitle: '选择要保留的更改',
    deviceSyncConflictsHelp: '这些记录发生了无法安全合并的变化。请逐一检查。此摘要页面不显示私密内容。',
    deviceSyncConflictVersions: '本设备',
    deviceSyncOtherDevice: '其他设备',
    deviceSyncKeepLocal: '保留本设备的版本',
    deviceSyncUseIncoming: '使用其他设备的版本',
    deviceSyncApplyChoices: '应用选择',
    deviceSyncChooseEveryConflict: '请为每个冲突选择一个选项。',
    linkADevice: '关联设备',
    generateLinkCode: '生成代码',
    linkPublicCorrelationWarning: '关联可能会公开表明两个化名身份由同一方控制。之后移除关联也无法抹去其他节点保存的早期签名关系副本。',
    linkPeerPreview: '身份指纹',
    approveAndLink: '批准并关联',
    enterLinkCode: '输入或扫描代码',
    linkCodeHelp: '请在代码过期前将其输入到另一台设备。',
    linkQrPlaceholderLabel: '包含此关联代码的二维码',
    linkQrCodeLabel: '包含此关联代码的二维码',
    linkQrRenderFailed: '无法生成二维码，请改用复制功能。',
    scanLinkCode: '使用相机扫描',
    cameraPermissionPrompt: '允许访问相机以扫描二维码。',
    cameraScanningQr: '请将相机对准二维码。',
    linkCodeScanned: '代码已扫描。请确认后点击“关联”。',
    cameraScanFailed: '无法使用相机扫描，请改为粘贴代码。',
    linkCodeTimeRemaining: '关联代码剩余时间',
    linkCodeInputLabel: '关联代码',
    linkCodeExpired: '代码已过期',
    refreshLinkStatus: '刷新状态',
    checkForLinkRequest: '检查关联请求',
    checkingForLinkRequest: '正在检查…',
    linkWaitingForOtherDevice: '正在等待另一台设备输入此代码。',
    linkApprovalPrompt: '批准与以下身份的直接关联：',
    approveLinkRequest: '批准关联',
    linkApprovalFailed: '无法验证并批准此请求。',
    linkApprovalComplete: '直接身份关联已验证。',
    linkCodePlaceholder: '粘贴关联代码',
    pasteFromClipboard: '粘贴',
    copyLink: '复制链接',
    shareLinkCode: '分享…',
    shareLinkCodeMessage: '在另一台设备上打开此链接，或在“设置 → 身份与设备”中输入此代码：',
    shareLinkCodeCopied: '已复制——可粘贴到任意应用中发送到你的另一台设备。',
    linkWithAppOnThisComputer: '与此计算机上的应用程序关联',
    linkErrorInvalid: '该代码无效。',
    linkErrorExpired: '该代码已过期。',
    linkErrorReused: '该身份已经关联。',
    linkErrorSelf: '不能将身份与其自身关联。',
    linkErrorUnavailable: '无法连接公共图谱，请重试。',
    unlinkTitle: '移除关联',
    unlinkConfirm: '移除与以下设备的关联：',
    unlinkConsequences: '这会停止通过此关联建立的未来信任，但不会抹除该设备、删除其本地数据、撤回公开记录或隐藏过去的关联。',
    removeLink: '移除关联',
    unlink: '取消关联',
    retryRevocation: '重试撤销',
    done: '完成',
    cancel: '取消',
    save: '保存',
    close: '关闭',
    link: '关联',
    settingsEraseDevice: '抹除此设备',
    settingsEraseDeviceHelp: '从这台电脑上移除你的身份和所有数据（适用于共享/公共电脑）。',
    settingsHelp: '帮助与导览',
    settingsHelpSubtitle: '查看入门话题，或重新播放产品介绍。',
    settingsStartGuide: '构建数字化的我',
    settingsReplayWalkthrough: 'IinPublic 如何运作',
    settingsHelpFaqHeading: '常见问题',
    walkthroughSkip: '跳过',
    walkthroughBack: '上一步',
    walkthroughNext: '下一步',
    walkthroughDone: '开始使用',
    walkthroughProgress: '第 {current} / {total} 步',
    walkthroughWelcomeTitle: '构建数字化的你',
    walkthroughWelcomeTagline: '只说一次，让数字化的你替你重复。',
    walkthroughWelcomeBody: '提问或回答一次，数字化的你便会在合适的情境下自动复用你的问题和已确认的答案。',
    walkthroughWelcomeNoLogin: '由你决定哪些自己提出的问题和给出的答案可以被复用。',
    walkthroughWelcomeResponsibility: '你只需处理新的内容。',
    walkthroughChatroomsTitle: '聊天室',
    walkthroughChatroomsTagline: '我身边的人都在聊什么？',
    walkthroughChatroomsBody: '按地点或话题加入聊天室，认识附近的人。',
    walkthroughChatroomsBroadcast: '向聊天室里的人广播你的话题。',
    walkthroughChatroomsReceive: '接收聊天室里其他人的话题。',
    walkthroughChatroomsNearby: '通过互联网或受支持的直接连接，发现附近的人。',
    walkthroughChatroomsOneToOne: '聊天室帮你发现他人；对话始终是一对一的。',
    walkthroughTalksTitle: '话题',
    walkthroughTalksTagline: '创建问题，让数字化的你代你提问。',
    walkthroughTalksBody: '在一个地方创建和回答问题，无需编程。',
    walkthroughTalksAnswerOwn: '回答自己提出的问题，分享你的想法。',
    walkthroughTalksAnswerOthers: '回应你收到的他人问题。',
    walkthroughTalksChatbotRepeat: '数字化的你只会重复你确认过的答案，不会自行编造。',
    walkthroughTalksReuse: '创建一次，保存、分享、反复使用。',
    walkthroughTalksOnlyNew: '你只需处理新的内容。',
    walkthroughContactsTitle: '联系人',
    walkthroughContactsTagline: '让共同点变成真正的连接。',
    walkthroughContactsBody: '当你和另一个人对同一个话题的回答相合时，就形成了匹配——在这里找到他们并开始聊天。',
    walkthroughContactsScale: '无需进行数百次一对一搜寻，便能找到合拍的人。',
    walkthroughMeTitle: '我',
    walkthroughMeTagline: '用每一个答案，塑造数字化的你。',
    walkthroughMeBody: '你的公众形象来自你的提问、回答、创作和贡献，而不只是一段自我介绍。',
    walkthroughMeIdentity: '我是谁？是你选择公开的那些问题与答案。',
    walkthroughMeStory: '你的答案讲述你的故事，并且随时可以查看或修改。',
    walkthroughSettingsTitle: '设置',
    walkthroughSettingsTagline: '你的应用，你的边界。',
    walkthroughSettingsBody: '调整过滤器、外观和隐私设置——你也可以随时从“设置 → 帮助与导览”重新播放本导览。',
    walkthroughSettingsData: '你的身份和私密数据由你控制，而不是由某一台服务器控制。',
    walkthroughSettingsReputation: '你的声誉来自他人，但展示多少由你决定。',
    walkthroughSettingsBoundaries: '选择什么可以到达你，屏蔽谁可以联系你；其他人也拥有同样的控制权。',
    settingsCreditVisible: '显示信誉/信用',
    settingsAllowedTypes: '允许的话题类型',
    settingsBlockedPhrases: '自定义屏蔽短语',
    settingsStorage: '存储检查',
    settingsRefresh: '刷新',
    settingsStorageLoading: '正在加载存储状态...',
    storageMode: '模式',
    storagePersistence: '持久性',
    storageLocalNode: '本地节点',
    storageDirectChat: '直接聊天',
    storageTransportFallback: '传输回退',
    storageSupportBootstrap: '支持引导',
    storageAppState: '应用状态',
    storageTechSupportRoot: 'TechSupport 根身份',
    techSupportRootBadge: 'TechSupport（根身份）',
    storageCurrentIdentity: '当前身份',
    storageSupportChannel: '支持频道',
    storageIncomingLanguages: '接收话题语言',
    storageDefaultTalkLanguage: '新话题默认语言',
    storageRoomVisits: '房间访问 / 独立访客',
    storageBrowserLocal: '浏览器本地存储',
    storageNoLocalKeys: '没有 localStorage 键',
    storageIndexedDb: 'IndexedDB',
    storageServerPaths: '服务器持久化路径',
    storageLocalNodeSupervisor: '本地节点管理器',
    storageStatus: '状态',
    storagePairing: '配对',
    storageBridge: '桥接',
    storageSeaCustody: 'SEA 身份保管',
    storageRelayScan: '中继扫描',
    storagePublicKeys: '公钥',
    storageForbidden: '禁止项',
    storageRelayRule: '中继仅可存储路由元数据、公钥、随机数、签名和密文。',
    storageConversationTransport: '对话传输',
    storageActive: '当前',
    storageMessages: '消息',
    storageReceipts: '回执',
    storageFallback: '回退',
    storageProtocol: 'P2P 网络协议',
    storageVersion: '版本',
    storageSubstrate: '底层协议',
    storageDiscoveryTtl: '发现 TTL',
    storageSignature: '签名',
    storageNeighborMemory: 'P2P 邻居记忆',
    storageScope: '范围',
    storageGraph: '图谱',
    storageClearNeighbors: '清除邻居',
    storageDisableMemory: '禁用记忆',
    storageExportEncrypted: '导出加密数据',
    storageBlockPeer: '屏蔽节点',
    storageBootstrap: '引导',
    storageDataOwnership: '数据归属',
    storageDeviceLocalDelete: '删除本机数据',
    storageServerHeldData: '服务器持有的数据',
    storageMigrationTarget: '迁移目标',
    storageLastLocalDelete: '上次本地删除',
    storageServerRequests: '服务器请求',
    storageMoveEligible: '迁移符合条件的数据',
    storageTransportDiagnostics: '传输诊断',
    storageDisclosureStorage: '存储',
    storageDisclosureBandwidth: '带宽',
    storageDisclosureBattery: '电池',
    storageDisclosureBackground: '后台行为',
    storageDisclosurePort: '本地端口',
    storageDisclosureStopDelete: '停止并删除',
    storageDeleteDeviceLocal: '删除此设备上的本地数据',
    storageRequestServerData: '请求/删除服务器持有的数据',
    storagePurposeProfile: '由用户控制的基础资料字段和私有问答镜像。',
    storagePurposePublicProfile: '昵称、头像、语言、兴趣以及按可见性过滤的资料字段。',
    storagePurposeReputation: '用于信用、屏蔽、年龄担保和发送限制的公开信誉计数。',
    storagePurposeChatrooms: '自动及自定义聊天室元数据与当前成员映射。',
    storagePurposeTalks: '广播及回复回放所需、由作者拥有的话题定义。',
    storagePurposeIncoming: '当前星型模式的话题投递收件箱与去重簇。',
    storagePurposeConversations: '为兼容性保留的星型模式匹配聊天记录，直连传输将替代它们。',
    storagePurposeTemplates: '由回答者拥有的聊天机器人答案模板和精确记忆记录。',
    storagePurposeExactMemory: '用于确定性复用答案的精确聊天机器人记忆索引。',
    storagePurposeStats: '经过隐私阈值处理且不含精确位置的话题回复汇总统计。',
    storageUnknown: '未知',
    storageDurable: '持久',
    storageEnabled: '已启用',
    storageDisabled: '已禁用',
    storageStopped: '已停止',
    storageStarting: '正在启动',
    storageRunning: '运行中',
    storageUnhealthy: '异常',
    storageStopping: '正在停止',
    storageWiped: '已清除',
    storageUnconfigured: '未配置',
    storageLocalOnly: '仅本地',
    storageAvailable: '可用',
    storageActiveValue: '活动',
    storageRequired: '必需',
    storageOptional: '可选',
    storageClean: '无异常',
    storageNeedsReview: '需要检查',
    storageSupported: '支持',
    storageLocal: '本地',
    storageOff: '关闭',
    storageShared: '共享',
    storagePrivate: '私有',
    storagePublished: '已发布',
    storageClears: '清除',
    storageNotRun: '尚未运行',
    storageNone: '无',
    storageQueued: '已排队',
    storageReview: '检查',
    storageTelemetryFree: '无遥测',
    storageLocalVisible: '仅本地可见',
    storageStarFallback: '星型回退',
    storageBlockedCount: '已屏蔽 {count} 个',
    settingsHiddenIncoming: '当前过滤条件隐藏的已收话题',
    broadcastPreviewTitle: '检查广播接收对象',
    broadcastPreviewHelp: '发送前会根据接收者的隐私和接收过滤设置进行检查。',
    broadcastPreviewEligible: '可接收',
    broadcastPreviewExcluded: '已排除',
    broadcastPreviewCancel: '取消',
    broadcastPreviewSend: '发送广播',
    broadcastPreviewUnavailable: '暂时无法预览；发送时将检查接收资格。',
    broadcastPreviewFinalCheck: '发送时最终检查',
    broadcastPreviewRecipients: '接收对象：{names}',
    broadcastPreviewSkipped: '已跳过：{details}',
    broadcastPreviewNone: '无',
    broadcastPreviewSupportExcluded: 'TechSupport 支持频道不参与普通广播（{count}）。',
    broadcastPreviewSenderOmitted: '不会从你的 OUT 列表发送',
    reasonIntakeLanguage: '不接受该语言',
    reasonIntakeTalkType: '不接受该话题类型',
    reasonIntakeMinDistance: '低于最小距离',
    reasonIntakeMaxDistance: '超过最大距离',
    reasonIntakeSentAfter: '早于时间过滤条件',
    reasonIntakeGrammar: '语法过滤',
    reasonIntakeDirtyWords: '内容审核过滤',
    reasonIntakeCustomTerms: '自定义屏蔽短语',
    reasonTalkExpired: '话题已过期',
    reasonBroadcastDisabled: '广播已关闭',
    reasonAgeGate: '需要年龄验证',
    reasonBlockedUser: '已被用户屏蔽',
    reasonBroadcastMaxDistance: '广播距离限制',
    reasonTagTargeting: '受众标签筛选',
    reasonCapacity: '发送容量限制',
    reasonRateLimit: '发送频率限制',
    statusBarUser: '{count} 位用户',
    statusBarUsers: '{count} 位用户',
    statusBarMatch: '{count} 个匹配',
    statusBarMatches: '{count} 个匹配',
    filterLocationPending: '位置尚未同步——距离过滤器暂不生效',
  },
} as const;

export type UiTranslationKey = keyof typeof CATALOG.en;

export function uiLanguageFromProfile(languages: string[] | undefined): UiLanguage {
  return String(languages?.[0] || 'en').toLowerCase() === 'zh' ? 'zh' : 'en';
}

export function uiText(language: UiLanguage, key: UiTranslationKey): string {
  return CATALOG[language][key];
}

export function languageOptionLabel(language: UiLanguage, code: string, fallback: string): string {
  if (language !== 'zh') return fallback;
  return ({
    en: '英语',
    zh: '中文',
    es: '西班牙语',
    fr: '法语',
    de: '德语',
    ja: '日语',
    ko: '韩语',
  } as Record<string, string>)[code] || fallback;
}
